/* Yes/No Tarot V3 engine - faithful runtime for the design markup.
   Live adaptations: theme header/footer replace the design's own, the card is
   drawn client-side from the complete 78-card pool and classified with the
   server's canonical lean sets, the draw registers a canonical free preview at
   /api/readings/free-reading (token + model insight), and checkout runs on the
   proven shared rail in its yes-no-direct presentation. */
(function () {
  'use strict';
  if (!document.querySelector('[data-yn3]')) return;

  var PAGE = '/pages/yes-or-no-tarot';
  var TYPE = 'Yes or No Tarot';
  var SPREAD = 'one-card-yes-no';
  var SCOPE = 'One-card Yes or No Tarot answer linking one canonical upright card to a directional lean, the reason for that lean, and one user-controlled check.';
  var CONFIDENCE = 'Symbolic reflection only; the directional lean is not proof, certainty, or a fixed outcome.';
  var DECK_VERSION = 'deckaura-rws-78-yesno-v1';
  var API_FREE = 'https://reading.deckaura.com/api/readings/free-reading';
  var KEY = 'deckaura.yesno.v3';
  var SAVE_KEY = 'deckaura.yesno.v3.session';
  var QUOTA_HANDOFF_KEY = 'deckaura:reading-handoff:v1';
  var SAVE_TTL = 2 * 60 * 60 * 1000;
  var FUNNEL_VARIANT = 'yes-no-intent-v1';
  var ANALYTICS_SCHEMA = 'yes_no_funnel_v1';
  var FUNNEL_VERSION = 'yes-no-enterprise-2026-08-24-v2';
  var SESSION_ID_KEY = 'deckaura.yesno.v1.session_id';
  var RESULT_MODES = ['success', 'fallback', 'limit', 'validation_error', 'network_error', 'server_error', 'timeout'];
  var PAGE_LANG = String((document.documentElement && document.documentElement.lang) || 'en').toLowerCase();
  var IS_TR = PAGE_LANG.indexOf('tr') === 0;
  var LOCALE_KEY = PAGE_LANG.indexOf('pt-br') === 0 ? 'pt-br' : PAGE_LANG.indexOf('pt-pt') === 0 ? 'pt-pt' : PAGE_LANG.slice(0, 2);
  var RUNTIME_COPY = window.YN3_TRANSLATIONS && window.YN3_TRANSLATIONS[LOCALE_KEY] || {};
  /* Clarity is intentionally deferred by the theme. Arm its documented
     in-memory queue before the first funnel event so page-entry events are not
     lost while consent and the network tag are still being resolved. */
  if (typeof window.clarity !== 'function') {
    window.clarity = function () {
      (window.clarity.q = window.clarity.q || []).push(arguments);
    };
  }
  function copy(en, tr) { return IS_TR ? tr : (RUNTIME_COPY[en] || en); }
  var CARD_I18N = window.YN3_CARD_I18N && window.YN3_CARD_I18N[LOCALE_KEY] || null;
  function cardLabel(name) {
    var source = String(name || '');
    if (!CARD_I18N || !source) return source;
    if (CARD_I18N.major && CARD_I18N.major[source]) return CARD_I18N.major[source];
    var match = /^(Ace|Two|Three|Four|Five|Six|Seven|Eight|Nine|Ten|Page|Knight|Queen|King) of (Wands|Cups|Swords|Pentacles)$/.exec(source);
    if (!match) return source;
    var rank = CARD_I18N.rank && CARD_I18N.rank[match[1]];
    var suit = CARD_I18N.suit && CARD_I18N.suit[match[2]];
    if (!rank || !suit) return source;
    return CARD_I18N.suitFirst ? suit + ' ' + rank : rank + (CARD_I18N.joiner || ' of ') + suit;
  }
  var RAIL_TIERS = ['deeper', 'indepth'];
  var PKG = [
    { id: 'focused', railTier: 'deeper', name: copy('Focused', 'Odaklı'), checkoutName: copy('Focused Personalized Answer', 'Odaklı Kişisel Yanıt'), price: '', previewPrice: 'US$9.99', available: false, value: copy('Compare Your Paths', 'Yollarını Karşılaştır'), label: copy('Best value', 'En iyi değer'), words: copy('750–950 private, personalized words', '750–950 kelimelik özel, kişisel yorum'),
      line1: copy('Your selected follow-up answered directly', 'Seçtiğiniz devam odağı doğrudan yanıtlanır'), line3: copy('Both paths, warnings and three practical next steps', 'İki yol, uyarılar ve üç pratik sonraki adım'), cta: '' },
    { id: 'indepth', railTier: 'indepth', name: copy('In-Depth', 'Derinlemesine'), checkoutName: copy('In-Depth Personalized Reading', 'Derinlemesine Kişisel Okuma'), price: '', previewPrice: 'US$16.99', available: false, value: copy('Map the Next 30 Days', 'Önündeki 30 Günü Haritala'), label: copy('Most complete', 'En kapsamlı'), words: copy('1,250–1,500 private, personalized words', '1.250–1.500 kelimelik özel, kişisel yorum'),
      line1: copy('Everything in the Focused reading', 'Odaklı okumadaki her şey'), line3: copy('Alternatives, safeguards and a practical 30-day map', 'Alternatifler, önlemler ve pratik 30 günlük harita'), cta: copy('Map my next 30 days', 'Önümdeki 30 günü haritala') }
  ];
  var INTENTS = {
    condition: {
      title: copy('Reveal the deciding condition', 'Belirleyici koşulu ortaya çıkar'),
      question: copy('What is the deciding condition shaping this answer?', 'Bu yanıtı şekillendiren belirleyici koşul nedir?'),
      detail: copy('See the one factor that could strengthen, weaken, or redirect this result.', 'Sonucu güçlendirebilecek, zayıflatabilecek veya yönünü değiştirebilecek etkeni gör.'),
      cta: copy('Continue this reading', 'Bu yoruma devam et'),
      pkg: 'focused'
    },
    paths: {
      title: copy('Compare acting now with waiting', 'Şimdi harekete geçmekle beklemeyi karşılaştır'),
      question: copy('What changes if I act now compared with waiting?', 'Şimdi harekete geçersem beklemeye kıyasla ne değişir?'),
      detail: copy('Compare both paths, their tradeoffs, and what each one asks of you.', 'İki yolu, bedellerini ve her birinin sizden ne istediğini karşılaştır.'),
      cta: copy('Compare my two paths', 'İki yolumu karşılaştır'),
      pkg: 'focused'
    },
    next: {
      title: copy('Find my most grounded next step', 'En sağlam sonraki adımımı bul'),
      question: copy('What is the most grounded next step within my control?', 'Kontrolümdeki en sağlam sonraki adım nedir?'),
      detail: copy('Turn the direction into a practical move without pretending the future is fixed.', 'Gelecek kesinmiş gibi davranmadan yönü pratik bir adıma dönüştür.'),
      cta: copy('Show my next step', 'Sonraki adımımı göster'),
      pkg: 'focused'
    }
  };
  var CATEGORIES = {
    love: { label: copy('Love & Connection', 'Aşk ve Bağ'), description: copy('Your continuation will stay focused on the relationship decision you control.', 'Devam okuması kontrolünüzdeki ilişki kararına odaklanır.') },
    career: { label: copy('Career & Purpose', 'Kariyer ve Amaç'), description: copy('Your continuation will stay focused on the work decision and observable tradeoffs.', 'Devam okuması iş kararına ve gözlemlenebilir sonuçlara odaklanır.') },
    timing: { label: copy('Timing & Momentum', 'Zamanlama ve İvme'), description: copy('Your continuation will stay focused on readiness, timing, and what changes between the two paths.', 'Devam okuması hazırlığa, zamanlamaya ve iki yol arasındaki değişime odaklanır.') },
    growth: { label: copy('Personal Growth', 'Kişisel Gelişim'), description: copy('Your continuation will stay focused on the pattern, boundary, and next move within your control.', 'Devam okuması kontrolünüzdeki örüntüye, sınıra ve sonraki adıma odaklanır.') },
    decision: { label: copy('Decision & Direction', 'Karar ve Yön'), description: copy('Your continuation will stay focused on the condition shaping this exact choice.', 'Devam okuması bu seçimi şekillendiren koşula odaklanır.') }
  };

  /* Sunucu lean setlerinin birebir aynasi (direct-tarot-tools.mjs). */
  var NOT_YET = ['The High Priestess', 'The Hanged Man', 'Temperance', 'Nine of Wands', 'Four of Swords', 'Page of Swords', 'Seven of Pentacles'];
  var IT_DEPENDS = ['The Hierophant', 'Justice', 'Seven of Wands', 'Seven of Cups', 'Two of Swords', 'Queen of Swords', 'Two of Pentacles'];
  var NO = ['The Hermit', 'Death', 'The Devil', 'The Tower', 'The Moon', 'Five of Wands', 'Ten of Wands', 'Four of Cups', 'Five of Cups', 'Eight of Cups', 'Three of Swords', 'Five of Swords', 'Seven of Swords', 'Eight of Swords', 'Nine of Swords', 'Ten of Swords', 'Knight of Swords', 'Four of Pentacles', 'Five of Pentacles'];
  var WHY = {
    'YES': 'The card supports movement when observable conditions align.',
    'NO': 'The card points to a limit, mismatch, or cost that deserves attention.',
    'NOT YET': 'The card favors patience while missing information or readiness develops.',
    'IT DEPENDS': 'The card makes the answer conditional on a choice or fact that is not settled yet.'
  };
  var CONTROL = 'Verify one observable fact and choose the next reversible step you control.';

  /* Full 78-card pool. Six cards missing from dkc use their dkl face asset. */
  var POOL = [
    'The Fool', 'The Magician', 'The High Priestess', 'The Empress', 'The Emperor', 'The Hierophant', 'The Lovers', 'The Chariot', 'Strength', 'The Hermit', 'Wheel of Fortune', 'Justice', 'The Hanged Man', 'Death', 'Temperance', 'The Devil', 'The Tower', 'The Star', 'The Moon', 'The Sun', 'Judgement', 'The World',
    'Ace of Wands', 'Two of Wands', 'Three of Wands', 'Four of Wands', 'Five of Wands', 'Six of Wands', 'Seven of Wands', 'Eight of Wands', 'Nine of Wands', 'Ten of Wands', 'Page of Wands', 'Knight of Wands', 'Queen of Wands', 'King of Wands',
    'Ace of Cups', 'Two of Cups', 'Three of Cups', 'Four of Cups', 'Five of Cups', 'Six of Cups', 'Seven of Cups', 'Eight of Cups', 'Nine of Cups', 'Ten of Cups', 'Page of Cups', 'Knight of Cups', 'Queen of Cups', 'King of Cups',
    'Ace of Swords', 'Two of Swords', 'Three of Swords', 'Four of Swords', 'Five of Swords', 'Six of Swords', 'Seven of Swords', 'Eight of Swords', 'Nine of Swords', 'Ten of Swords', 'Page of Swords', 'Knight of Swords', 'Queen of Swords', 'King of Swords',
    'Ace of Pentacles', 'Two of Pentacles', 'Three of Pentacles', 'Four of Pentacles', 'Five of Pentacles', 'Six of Pentacles', 'Seven of Pentacles', 'Eight of Pentacles', 'Nine of Pentacles', 'Ten of Pentacles', 'Page of Pentacles', 'Knight of Pentacles', 'Queen of Pentacles', 'King of Pentacles'
  ];
  var DKL_ONLY = ['The Fool', 'Ten of Pentacles', 'Page of Pentacles', 'Knight of Pentacles', 'Queen of Pentacles', 'King of Pentacles'];
  function leanOf(name) {
    if (NOT_YET.indexOf(name) >= 0) return 'NOT YET';
    if (IT_DEPENDS.indexOf(name) >= 0) return 'IT DEPENDS';
    if (NO.indexOf(name) >= 0) return 'NO';
    return 'YES';
  }
  function canonicalSignals(name) {
    var lean = leanOf(name);
    return 'The Answer: ' + name + ' Upright; Directional Lean: ' + lean + '; Why: ' + WHY[lean] + '; User Control: ' + CONTROL + '; Deck Version: ' + DECK_VERSION;
  }

  /* A small local theme fallback; the server owns the concise card rationale. */
  var CURATED = {
    'The Sun': { theme: 'Clarity and visible progress' },
    'The Star': { theme: 'Renewed trust after strain' },
    'The Chariot': { theme: 'Directed momentum' },
    'Ten of Cups': { theme: 'Emotional completion' },
    'The Tower': { theme: 'A structure that will not hold' },
    'Five of Pentacles': { theme: 'Depleted resources' },
    'Eight of Cups': { theme: 'A quiet departure' },
    'The Hanged Man': { theme: 'Suspended timing' },
    'Four of Swords': { theme: 'A required pause' },
    'Two of Swords': { theme: 'A decision held at arm’s length' },
    'Justice': { theme: 'Cause and effect on the scales' },
    'Seven of Cups': { theme: 'Too many open options' }
  };
  var DIRS = {
    'YES': { ink: '#8FC9A8', inkDark: '#3F6B54', label: copy('Yes', 'Evet'),
      lead: copy('This card gives the question a positive directional lean.', 'Bu kart sorunuza olumlu bir yön verir.'),
      criticalQuestion: copy('What protects this Yes, and what could change it?', 'Bu Eveti ne koruyor ve ne değiştirebilir?'),
      head: copy('Your answer leans Yes. Now see what protects it.', 'Yanıtınız Evet yönünde. Şimdi onu neyin koruduğunu görün.'),
      sub: copy('Understand what supports this Yes, what could weaken it, and the clearest way to move forward without rushing.', 'Bu Eveti neyin desteklediğini, neyin zayıflatabileceğini ve acele etmeden nasıl ilerleyebileceğinizi anlayın.') },
    'NO': { ink: '#B77B90', inkDark: '#7B3F58', label: copy('No', 'Hayır'),
      lead: copy('This card gives the question a negative directional lean.', 'Bu kart sorunuza olumsuz bir yön verir.'),
      criticalQuestion: copy('Is this No a firm boundary or a redirection?', 'Bu Hayır kesin bir sınır mı, yoksa yeni bir yön mü?'),
      head: copy('Your answer leans No. Is it a firm boundary or a redirection?', 'Yanıtınız Hayır yönünde. Bu kesin bir sınır mı, yoksa yeniden yönlenme mi?'),
      sub: copy('See what is blocking this path and whether the condition can change.', 'Bu yolu neyin engellediğini ve koşulun değişip değişemeyeceğini görün.') },
    'NOT YET': { ink: '#C79A5E', inkDark: '#7E5A22', label: copy('Not Yet', 'Henüz Değil'),
      lead: copy('This card gives the question a Not Yet directional lean.', 'Bu kart sorunuza Henüz Değil yönü verir.'),
      criticalQuestion: copy('What needs to change before this can move?', 'Bu durum ilerlemeden önce neyin değişmesi gerekiyor?'),
      head: copy('The answer is Not Yet. Find out what needs to change first.', 'Yanıt Henüz Değil. Önce neyin değişmesi gerektiğini bulun.'),
      sub: copy('Identify the missing condition, what you can prepare now, and when to reassess.', 'Eksik koşulu, şimdi ne hazırlayabileceğinizi ve ne zaman yeniden değerlendireceğinizi belirleyin.') },
    'IT DEPENDS': { ink: '#C9C2EA', inkDark: '#56536E', label: copy('It Depends', 'Koşula Bağlı'),
      lead: copy('This card gives the question a conditional directional lean.', 'Bu kart sorunuza koşullu bir yön verir.'),
      criticalQuestion: copy('Which condition is deciding the outcome?', 'Sonucu hangi koşul belirliyor?'),
      head: copy('Your result depends on one deciding condition. Identify it before you act.', 'Sonucunuz belirleyici bir koşula bağlı. Harekete geçmeden önce onu belirleyin.'),
      sub: copy('See which factor is shaping the outcome and the choice within your control.', 'Sonucu şekillendiren etkeni ve kontrolünüzde kalan seçimi görün.') }
  };

  /* ------------ state ------------ */
  var s = {
    q: '', err: '', phase: 'ask', card: '', pkg: 'focused',
    ctx: '', ctxOpen: false, restored: false,
    readingId: '', previewToken: '', previewContext: '', previewReadingContext: '', transportFallback: false, transportFailure: '', insight: '', fetching: false, buying: false,
    checkoutQueued: false, checkoutVia: '', railReadingId: '', railPreviewToken: '', authorityRepairUsed: false, checkoutCartReview: null,
    category: 'decision', intent: 'condition',
    compareOpen: false, limit: null, limitKept: false, paidOnly: false,
    serverFallback: false, fallbackSource: '',
    sessionId: '', attemptId: '', sentEvents: {}, questionStarted: false,
    resultMode: '', pricing: { status: 'idle', currency: '', latency_ms: 0, error_code: '', tiers: [] },
    resultViewed: false, resultEngaged: false, lockExpiresAt: 0
  };
  var activeFreeRequest = null;
  var railLoadStatus = 'idle';
  var railLoadTimer = 0;
  var railLoadGeneration = 0;
  var railRuntimeScript = null;
  var drawTimer = 0;
  var checkoutTimer = 0;
  var railMountRetry = 0;
  var railMountAttempts = 0;
  var railPriceRetry = 0;
  var railPriceAttempts = 0;
  var railSyncing = false;
  var railEnabled = false;
  var milestoneObserver = null;
  var seenMilestones = {};
  var visibilityTimers = {};
  var engagedVisible = false;
  var engagedLastTick = 0;
  var engagedMs = 0;
  var engagedTimer = 0;

  function validPreviewToken(value) {
    return /^[a-f0-9]{32}$/i.test(String(value || ''));
  }
  function validTransportFailure(value) {
    return /^(?:timeout|http_408|http_429|http_5xx)$/.test(String(value || ''));
  }
  function transportFailureForStatus(status) {
    var code = Number(status) || 0;
    if (code === 408) return 'http_408';
    if (code === 429) return 'http_429';
    if (code >= 500) return 'http_5xx';
    return '';
  }
  function currentAuthorizationContext() {
    var dl = window.DeckauraLocale || {};
    var activeCurrency = '';
    try { activeCurrency = (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) || ''; } catch (_) {}
    return {
      language: String(dl.language || PAGE_LANG || 'en').toLowerCase().replace(/_/g, '-').slice(0, 24),
      locale: String(dl.locale || (document.documentElement && document.documentElement.lang) || PAGE_LANG || 'en').toLowerCase().replace(/_/g, '-').slice(0, 24),
      country: String(dl.country || 'US').toUpperCase().replace(/[^A-Z]/g, '').slice(0, 2),
      currency: String(dl.currency || activeCurrency || 'USD').toUpperCase().replace(/[^A-Z]/g, '').slice(0, 3),
      market: String(dl.market || '').toLowerCase().replace(/\s+/g, '-').replace(/[^a-z0-9-]/g, '').slice(0, 64)
    };
  }
  function authorizationContextKey(context) {
    var value = context && typeof context === 'object' ? context : currentAuthorizationContext();
    return [value.locale, value.country, value.currency, value.market].join('|');
  }
  function authorizationContextMatches(value) {
    return !!value && String(value) === authorizationContextKey();
  }
  function contextHash(value) {
    var input = String(value || '');
    var hash = 2166136261;
    for (var i = 0; i < input.length; i++) {
      hash ^= input.charCodeAt(i);
      hash = Math.imul(hash, 16777619);
    }
    return (hash >>> 0).toString(36).padStart(7, '0').slice(-7);
  }
  function contextualReadingId(value, contextKey) {
    var base = String(value || '').replace(/-lc-[a-z0-9]{7}$/i, '');
    if (!/^[a-z0-9-]{6,80}$/i.test(base)) base = 'yn3-' + Date.now().toString(36) + Math.random().toString(36).slice(2, 7);
    return (base.slice(0, 69) + '-lc-' + contextHash(contextKey || authorizationContextKey())).slice(0, 80);
  }
  function readingAuthorizationKey() {
    return JSON.stringify([s.readingId, String(s.q || '').trim(), s.card, authorizationContextKey()]);
  }
  function cancelFreeRequest() {
    var request = activeFreeRequest;
    activeFreeRequest = null;
    s.fetching = false;
    if (!request) return;
    if (request.timer) clearTimeout(request.timer);
    if (request.controller) request.controller.abort();
  }
  function checkoutAuthorized() {
    if (!authorizationContextMatches(s.previewContext) || s.previewReadingContext !== readingAuthorizationKey()) return false;
    return validPreviewToken(s.previewToken) || (s.transportFallback === true && validTransportFailure(s.transportFailure));
  }
  function checkoutAuthorizationKey() {
    if (validPreviewToken(s.previewToken)) return 'token:' + s.previewToken + ':' + s.previewContext;
    if (s.transportFallback === true && validTransportFailure(s.transportFailure)) return 'fallback:' + s.transportFailure + ':' + s.previewContext;
    return 'pending';
  }
  function clearPreviewAuthorization() {
    s.previewToken = '';
    s.previewContext = '';
    s.previewReadingContext = '';
    s.transportFallback = false;
    s.transportFailure = '';
  }

  function safeId(value) { return /^[a-zA-Z0-9_-]{12,96}$/.test(String(value || '')); }
  function uuid(prefix) {
    try {
      if (crypto && typeof crypto.randomUUID === 'function') return (prefix || '') + crypto.randomUUID();
      var bytes = new Uint8Array(16); crypto.getRandomValues(bytes);
      return (prefix || '') + Array.prototype.map.call(bytes, function (x) { return x.toString(16).padStart(2, '0'); }).join('');
    } catch (_) { return (prefix || '') + Date.now().toString(36) + Math.random().toString(36).slice(2, 14); }
  }
  function sessionId() {
    try {
      var existing = sessionStorage.getItem(SESSION_ID_KEY);
      if (safeId(existing)) return existing;
      var next = uuid('s_');
      sessionStorage.setItem(SESSION_ID_KEY, next);
      return next;
    } catch (_) { return uuid('s_'); }
  }
  function cleanToken(value, max) {
    return String(value == null ? '' : value).toLowerCase().replace(/[^a-z0-9_:-]/g, '_').slice(0, max || 80);
  }
  function safeEventData(data) {
    var allowed = {
      category: 1, intent: 1, tier: 1, via: 1, result_mode: 1, source: 1,
      status: 1, currency: 1, latency_ms: 1, error_code: 1, variant_id: 1,
      price_minor: 1, available: 1, reason: 1, destination: 1, lean: 1
    };
    var out = {};
    Object.keys(data || {}).forEach(function (key) {
      if (!allowed[key]) return;
      var value = data[key];
      if (typeof value === 'number' && Number.isFinite(value)) out[key] = value;
      else if (typeof value === 'boolean') out[key] = value;
      else if (value != null) out[key] = key === 'currency'
        ? String(value).toUpperCase().replace(/[^A-Z]/g, '').slice(0, 3)
        : cleanToken(value, key === 'variant_id' ? 24 : 80);
    });
    return out;
  }
  function publishFunnelEvent(name, data, options) {
    if (isInternalAudit()) return false;
    if (!/^[a-z][a-z0-9_]{2,64}$/.test(String(name || ''))) return false;
    if (name === 'free_result_resolved' && RESULT_MODES.indexOf(String(data && data.result_mode || '')) < 0) {
      data = Object.assign({}, data || {}, { result_mode: 'server_error' });
    }
    var once = options && options.once === true;
    var scope = s.attemptId || s.sessionId || 'page';
    var dedupeKey = scope + ':' + name;
    if (once && s.sentEvents[dedupeKey]) return false;
    var locale = String((window.DeckauraLocale && window.DeckauraLocale.locale) || PAGE_LANG || 'en').slice(0, 24);
    var country = String((window.DeckauraLocale && window.DeckauraLocale.country) || '').toUpperCase().replace(/[^A-Z]/g, '').slice(0, 2);
    var payload = Object.assign({
      analytics_schema: ANALYTICS_SCHEMA,
      funnel_version: FUNNEL_VERSION,
      session_id: s.sessionId,
      attempt_id: s.attemptId || '',
      reading_id: s.readingId || '',
      event_uuid: uuid('e_'),
      occurred_at: new Date().toISOString(),
      locale: locale,
      country: country
    }, safeEventData(data));
    if (once) {
      s.sentEvents[dedupeKey] = payload.event_uuid;
      persistState();
    }
    try {
      if (window.Shopify && window.Shopify.analytics && typeof window.Shopify.analytics.publish === 'function') {
        window.Shopify.analytics.publish(name, payload);
      }
    } catch (_) {}
    try { if (typeof window.clarity === 'function') window.clarity('event', name); } catch (_) {}
    try { document.dispatchEvent(new CustomEvent('deckaura:yes-no-funnel-event', { detail: { name: name, payload: payload } })); } catch (_) {}
    return true;
  }
  function isInternalAudit() {
    var internal = false;
    try {
      var params = new URL(window.location.href).searchParams;
      internal = params.has('funnel_audit') || params.get('internal') === 'true' || params.get('traffic_type') === 'internal'
        || params.has('deckaura_internal') || params.has('codex_audit') || params.has('alltools_audit');
    } catch (_) {}
    try {
      if (internal) sessionStorage.setItem('deckaura.yn3.internal-audit.v1', '1');
      return internal || sessionStorage.getItem('deckaura.yn3.internal-audit.v1') === '1';
    } catch (_) { return internal; }
  }
  function ensureAttempt(source) {
    if (s.attemptId) return s.attemptId;
    s.attemptId = uuid('a_');
    s.sentEvents = {};
    publishFunnelEvent('first_interaction', { source: source || 'unknown' }, { once: true });
    persistState();
    return s.attemptId;
  }
  function foldWord(value) {
    var word = String(value || '').toLocaleLowerCase(IS_TR ? 'tr-TR' : undefined);
    try { word = word.normalize('NFD').replace(/[\u0300-\u036f]/g, ''); } catch (_) {}
    return word.replace(/ı/g, 'i').replace(/ß/g, 'ss');
  }
  function questionWords(question) {
    var value = norm(question), words = [];
    try { words = value.split(/[^\p{L}\p{N}]+/u); }
    catch (_) { words = value.split(/[^a-z0-9\u00c0-\u024f\u1e00-\u1eff]+/i); }
    return words.filter(Boolean).map(function (word) { return { raw: word, folded: foldWord(word) }; });
  }
  function hasWordStem(words, stems, exactWords) {
    exactWords = exactWords || [];
    return words.some(function (word) {
      if (exactWords.indexOf(word.raw) >= 0 || exactWords.indexOf(word.folded) >= 0) return true;
      return stems.some(function (stem) {
        return word.folded === stem || (word.folded.indexOf(stem) === 0 && word.folded.length <= stem.length + 10);
      });
    });
  }
  function categoryOf(question) {
    var words = questionWords(question);
    if (hasWordStem(words, ['love','relationship','partner','dating','marri','breakup','romanc','amor','relacion','parej','cita','matrimonio','bezieh','lieb','heirat','relacionamento','relacao','parceir','encontro','casamento','ask','iliski','flort','evlilik','ayrilik','sevgi'])) return 'love';
    if (hasWordStem(words, ['job','career','work','business','client','promot','raise','salary','interview','manager','company','project','meeting','offer','trabaj','carrera','empleo','negocio','salario','entrevista','oferta','arbeit','beruf','karriere','gehalt','bewerb','angebot','trabalho','carreira','emprego','proposta','kariyer','maas','mulakat','teklif','proje'], ['iş'])) return 'career';
    if (hasWordStem(words, ['when','timing','today','tomorrow','week','month','soon','ready','wait','delay','later','cuando','hoy','manana','semana','esperar','ahora','despues','wann','heute','morgen','woche','monat','warten','jetzt','spater','quando','hoje','amanha','agora','depois','bugun','yarin','hafta','bekle','simdi','sonra'], ['now','mes','mês','ay'])) return 'timing';
    if (hasWordStem(words, ['growth','habit','boundary','heal','confidence','purpose','personal','crecimiento','habito','limite','sanar','confianza','proposito','wachstum','gewohnheit','grenze','heilung','vertrauen','ziel','crescimento','cura','confianca','gelisim','aliskanlik','sinir','iyilesme','guven','amac'])) return 'growth';
    return 'decision';
  }
  function categoryConfig() { return CATEGORIES[s.category] || CATEGORIES.decision; }
  function intentConfig() { return INTENTS[s.intent] || null; }
  function visitorId() {
    var key = 'deckaura_visitor_v1';
    try {
      var existing = localStorage.getItem(key);
      if (existing && /^[a-zA-Z0-9_-]{16,96}$/.test(existing)) return existing;
      var bytes = new Uint8Array(18); crypto.getRandomValues(bytes);
      var next = 'v_' + Array.prototype.map.call(bytes, function (x) { return x.toString(16).padStart(2, '0'); }).join('');
      localStorage.setItem(key, next);
      return next;
    } catch (_) { return 'v_' + Date.now().toString(16) + Math.random().toString(36).slice(2, 10); }
  }
  function persistState() {
    try {
      if (s.q && needsQualifiedSupport(s.q)) { sessionStorage.removeItem(SAVE_KEY); return; }
      sessionStorage.setItem(SAVE_KEY, JSON.stringify({
        ts: Date.now(), q: s.q, phase: s.phase, card: s.card, pkg: s.pkg,
        ctx: s.ctx, ctxOpen: s.ctxOpen, restored: s.restored,
        readingId: s.readingId, previewToken: s.previewToken, previewContext: s.previewContext, previewReadingContext: s.previewReadingContext, authorityRepairUsed: s.authorityRepairUsed,
        transportFallback: s.transportFallback, transportFailure: s.transportFailure, insight: s.insight,
        category: s.category, intent: s.intent, compareOpen: s.compareOpen,
        paidOnly: s.paidOnly, serverFallback: s.serverFallback, fallbackSource: s.fallbackSource,
        sessionId: s.sessionId, attemptId: s.attemptId, sentEvents: s.sentEvents,
        questionStarted: s.questionStarted, resultMode: s.resultMode,
        resultViewed: s.resultViewed, resultEngaged: s.resultEngaged, lockExpiresAt: s.lockExpiresAt
      }));
    } catch (_) {}
  }
  function restoreState() {
    var saved = null;
    try { saved = JSON.parse(sessionStorage.getItem(SAVE_KEY) || 'null'); } catch (_) { saved = null; }
    if (!saved || !saved.ts || Date.now() - Number(saved.ts) > SAVE_TTL) return false;
    var question = String(saved.q || '').trim().slice(0, 180);
    /* A saved question is checked again: a crisis text is never restored, whatever an older version saved. */
    if (question && needsQualifiedSupport(question)) {
      try { sessionStorage.removeItem(SAVE_KEY); } catch (_) {}
      return false;
    }
    var card = String(saved.card || '');
    s.q = question;
    s.pkg = PKG.some(function (item) { return item.id === saved.pkg; }) ? saved.pkg : 'focused';
    s.ctx = String(saved.ctx || '').slice(0, 700);
    s.ctxOpen = saved.ctxOpen === true;
    s.restored = saved.restored === true;
    s.readingId = /^[a-z0-9-]{6,80}$/i.test(String(saved.readingId || '')) ? String(saved.readingId) : '';
    s.authorityRepairUsed = saved.authorityRepairUsed === true;
    clearPreviewAuthorization();
    s.insight = String(saved.insight || '').replace(/\s+/g, ' ').trim().slice(0, 900);
    s.category = Object.prototype.hasOwnProperty.call(CATEGORIES, saved.category) ? saved.category : categoryOf(question);
    /* The compact result has no mandatory focus step. Normalize legacy saved
       sessions to the single signed focus while preserving a valid paid depth. */
    s.intent = 'condition';
    s.compareOpen = false;
    s.paidOnly = saved.paidOnly === true;
    s.serverFallback = saved.serverFallback === true;
    s.fallbackSource = String(saved.fallbackSource || '').replace(/[^a-z0-9_-]/gi, '').slice(0, 48);
    s.sessionId = safeId(saved.sessionId) ? String(saved.sessionId) : s.sessionId;
    s.attemptId = safeId(saved.attemptId) ? String(saved.attemptId) : '';
    s.sentEvents = saved.sentEvents && typeof saved.sentEvents === 'object' ? saved.sentEvents : {};
    s.questionStarted = saved.questionStarted === true;
    s.resultMode = RESULT_MODES.indexOf(saved.resultMode) >= 0 ? saved.resultMode : '';
    s.resultViewed = saved.resultViewed === true;
    s.resultEngaged = saved.resultEngaged === true;
    s.lockExpiresAt = Math.max(Number(saved.lockExpiresAt) || 0, Number((activeLockRecord() || {}).expiresAt) || 0);
    if (question.length >= 8 && POOL.indexOf(card) >= 0 && saved.phase === 'result') {
      s.card = card;
      /* Session storage is private to this tab. Reuse only a canonical token
         (or the rail's narrowly authorized transport fallback) while this
         saved reading snapshot is still valid. A second preview request for
         the same 24-hour reading is correctly rate-limited. */
      var restoredToken = String(saved.previewToken || '');
      var restoredContext = String(saved.previewContext || '');
      var savedAuthorization = validPreviewToken(restoredToken)
        || (saved.transportFallback === true && validTransportFailure(saved.transportFailure));
      var identityMatches = String(saved.previewReadingContext || '') === readingAuthorizationKey();
      if (savedAuthorization && !authorizationContextMatches(restoredContext)) {
        s.readingId = contextualReadingId(s.readingId, authorizationContextKey());
      } else if (identityMatches && validPreviewToken(restoredToken)) {
        s.previewToken = restoredToken;
        s.previewContext = restoredContext;
      } else if (identityMatches && saved.transportFallback === true && validTransportFailure(saved.transportFailure)) {
        s.previewContext = restoredContext;
        s.transportFallback = true;
        s.transportFailure = String(saved.transportFailure);
      }
      if (identityMatches && authorizationContextMatches(restoredContext)) s.previewReadingContext = readingAuthorizationKey();
      if (!identityMatches) s.insight = localInsight();
      if (LOCALE_KEY !== 'en' && looksEnglishInsight(s.insight)) s.insight = localInsight();
      else if (s.insight) s.insight = sanitizeFreeInsight(s.insight);
      s.phase = 'result';
      s.restored = true;
      return true;
    }
    s.phase = 'ask';
    return false;
  }
  function categoryReason() {
    if (s.category === 'love') return copy('The imagery centers the balance between openness, distance, and emotional exchange in this connection.', 'Kartın imgeleri bu bağdaki açıklık, mesafe ve duygusal alışveriş dengesine odaklanır.');
    if (s.category === 'career') return copy('The imagery centers momentum, friction, and the shape of this opportunity.', 'Kartın imgeleri ivmeye, sürtüşmeye ve bu fırsatın yapısına odaklanır.');
    if (s.category === 'timing') return copy('The imagery centers pace, pause, and present readiness.', 'Kartın imgeleri hıza, duraklamaya ve mevcut hazırlığa odaklanır.');
    if (s.category === 'growth') return copy('The imagery centers the personal pattern that is most active now.', 'Kartın imgeleri şu anda en etkin olan kişisel örüntüye odaklanır.');
    return copy('The imagery centers momentum, resistance, and clarity around this choice.', 'Kartın imgeleri bu seçim çevresindeki ivmeye, dirence ve netliğe odaklanır.');
  }
  function freeCompactContract() {
    var name=cardLabel(s.card);
    return {kind:'yes_no',locale:LOCALE_KEY,question:s.q,answer:leanOf(s.card),cards:s.card?[{card:s.card,displayName:name,aliases:[s.card,name],orientation:'Upright'}]:[]};
  }
  function sanitizeFreeInsight(raw) {
    var text=String(raw||'').replace(/<[^>]*>/g,' ').replace(/\s+/g,' ').trim();
    return window.DeckauraFreeCompact && window.DeckauraFreeCompact.validated(text,freeCompactContract()) || localInsight();
  }
  function looksEnglishInsight(raw) {
    var value = ' ' + String(raw || '').toLowerCase().replace(/[^a-z]+/g, ' ') + ' ';
    var hits = [' the ', ' this ', ' your ', ' card ', ' brings ', ' into ', ' direction ', ' condition ', ' question ', ' suggests ']
      .reduce(function (count, token) { return count + (value.indexOf(token) >= 0 ? 1 : 0); }, 0);
    return hits >= 2;
  }
  function localInsight() {
    return s.card && window.DeckauraFreeCompact ? window.DeckauraFreeCompact.direct(freeCompactContract()) : '';
  }
  function cardSlug(name) {
    return String(name || '').toLowerCase().replace(/^the\s+/, '').replace(/[^a-z0-9]+/g, '-').replace(/^-+|-+$/g, '');
  }
  function cardImg(name) {
    return window.DeckauraTarotArt ? window.DeckauraTarotArt.url(name, 720) : '';
  }

  /* ------------ question validation (tasarimin kurallari) ------------ */
  var MIND_READING = /what (does|do|is) (he|she|they|him|her)|how (does|do) (he|she|they) feel|does (he|she|they) (love|miss|like|want)|(his|her|their) (real|true|honest) (thoughts|feelings)|qu[eé] (piensa|siente|quiere) (el|él|ella)|c[oó]mo se siente|was (denkt|f[uü]hlt|will) (er|sie)|wie f[uü]hlt|o que (ele|ela) (pensa|sente|quer)|como (ele|ela) se sente|o ne (düşünüyor|hissediyor|istiyor)|ne hissediyor/i;
  var TWO_QUESTIONS = /\bor should\b|should i .+\b(or|and) should i\b|\bshould (i|we)\b.*\bshould (i|we)\b/i;
  /* Only crisis wording (the shared guard's 'urgent', assets/deckaura-crisis-guard.js, loaded before this file by
     sections/yn3-stage.liquid) or a question the reading service refused for safety stops the draw. A medical, legal or
     money detail ("Will I get pregnant this year?", "My doctor said I am healthy") is an ordinary question here: the
     guard's 'high' never holds a draw or checkout. */
  function crisisGuard() {
    var g = window.DeckauraCrisisGuard;
    return g && typeof g.classify === 'function' ? g : null;
  }
  /* Crisis wording from the shared guard. Without the guard nothing is screened here; the reading service's
     *_SAFETY_BLOCKED refusal is the backstop (see the failure handlers). */
  function urgentQuestion(text) {
    var g = crisisGuard();
    if (!g || !String(text || '').trim()) return false;
    try { var r = g.classify(text); return !!r && r.kind === 'urgent'; } catch (_) { return false; }
  }
  function needsQualifiedSupport(raw) {
    return heldForSafety(raw) || urgentQuestion(raw);
  }
  /* kind: 'urgent' (crisis wording) or 'blocked' (the reading service refused the question for safety). The copy comes
     from the shared guard in the page language; the local text is the fallback without it. */
  function supportMessage(kind) {
    if (kind === 'urgent' || kind === 'blocked') {
      var g = window.DeckauraCrisisGuard;
      try { if (g && typeof g.message === 'function') { var m = g.message(kind, PAGE_LANG); if (m) return m; } } catch (_) {}
    }
    return copy('This decision needs qualified support, not a tarot answer. Please use an appropriate medical, legal, financial, or emergency professional.', 'Bu karar tarot yanıtı değil, yetkin destek gerektirir. Lütfen uygun bir tıp, hukuk, finans veya acil durum uzmanına başvurun.');
  }
  function supportFor(text) { return supportMessage(heldForSafety(text) ? 'blocked' : urgentQuestion(text) ? 'urgent' : 'high'); }
  /* A question the reading service refused for safety stays refused in this tab until it changes. Only a hash is kept. */
  var safetyHeldKey = '';
  function heldForSafety(text) { return !!safetyHeldKey && safetyHeldKey === contextHash(norm(text)); }
  function holdForSafety() {
    safetyHeldKey = contextHash(norm(s.q));
    /* The rolling free-draw window is kept; the refused text is removed from both stores. */
    try {
      var store = JSON.parse(localStorage.getItem(KEY) || '{}');
      if (store && store.ts) { store.question = ''; store.key = ''; localStorage.setItem(KEY, JSON.stringify(store)); }
    } catch (_) {}
    try { sessionStorage.removeItem(SAVE_KEY); } catch (_) {}
  }
  /* The free reading was refused for safety: back to the question with the support message, no card, no offer. */
  function refuseForSafety() {
    holdForSafety();
    if (drawTimer) clearTimeout(drawTimer);
    drawTimer = 0;
    s.phase = 'ask'; s.card = ''; s.insight = ''; s.limit = null; s.buying = false; s.checkoutQueued = false;
    clearPreviewAuthorization();
    s.resultMode = 'validation_error';
    publishFunnelEvent('free_result_resolved', { result_mode: 'validation_error', reason: 'safety_blocked' }, { once: true });
    showQuestionError(supportMessage('blocked'));
  }
  /* A refused question gets a one-tap answerable version instead of a dead end. */
  function rewriteSuggestion(raw) {
    var t = String(raw || '').trim();
    /* Never turn a question that needs support into a sellable one. */
    if (!t || needsQualifiedSupport(t)) return '';
    var clauses = t.split(/\?|\s+(?:or|and)\s+should\s+(?:i|we)\b/i);
    /* The chip replaces the text: the mind-reading chip drops all of it, the
       two-question chip everything after the first clause. Nothing about
       living or dying may be dropped that way. */
    var dropped = MIND_READING.test(t) ? t : clauses.slice(1).join(' ');
    var guard = crisisGuard();
    if (!guard || typeof guard.touchesLifeOrDeath !== 'function' || guard.touchesLifeOrDeath(dropped)) return '';
    var suggestion = '';
    if (MIND_READING.test(t)) suggestion = copy('Is this connection good for me right now?', 'Bu bağ şu an benim için iyi mi?');
    else if ((t.match(/\?/g) || []).length > 1 || TWO_QUESTIONS.test(t)) {
      var first = clauses[0].replace(/[\s,;:.!-]+$/, '').trim();
      if (first) suggestion = first + '?';
    }
    return suggestion && suggestion !== t && !validate(suggestion) ? suggestion : '';
  }
  function validate(raw) {
    var t = String(raw || '').trim();
    if (!t) return copy('Enter one yes-or-no question before drawing your card.', 'Kartınızı çekmeden önce tek bir evet veya hayır sorusu yazın.');
    /* Safety wins over every shape check, so a short, shapeless or two-part
       question that mentions self-harm or a medical/legal/financial matter
       always gets the support message and no rewrite chip. */
    if (needsQualifiedSupport(t)) return supportFor(t);
    if (t.length < 8) return copy('Turn this into a complete yes-or-no question, such as “Should I move forward?”', 'Bunu “İlerlemeli miyim?” gibi tam bir evet veya hayır sorusuna dönüştürün.');
    if (t.length > 180) return copy('Keep the question under 180 characters so the answer stays focused.', 'Yanıtın odaklı kalması için sorunuzu 180 karakterin altında tutun.');
    var yesNoShape = /\?|\b(?:should|will|would|can|could|is|are|am|do|does|did|may|might|has|have|was|were|debo|deber[ií]a|puedo|puede|conviene|soll|sollte|kann|wird|ist|sind|darf|devo|deveria|posso|pode|ser[aá]|conv[eé]m)\b/i.test(t)
      || /(?:^|\s)(?:mi|mı|mu|mü|miyim|mıyım|muyum|müyüm|miyiz|mıyız|muyuz|müyüz|misin|mısın|musun|müsün|misiniz|mısınız|musunuz|müsünüz)[?.!]?(?:\s|$)/i.test(t);
    if (!yesNoShape || !/[a-zA-ZÀ-ɏ]/.test(t)) return copy('Make this a yes-or-no decision, for example “Should I accept this opportunity?”', 'Bunu evet veya hayırla yanıtlanabilir bir karara dönüştürün; örneğin “Bu fırsatı kabul etmeli miyim?”');
    var qs = (t.match(/\?/g) || []).length;
    if (qs > 1 || TWO_QUESTIONS.test(t)) return copy('This sounds like two questions. Choose the one decision that matters most right now.', 'Bu iki ayrı soru gibi görünüyor. Şu anda en önemli olan tek kararı seçin.');
    if (MIND_READING.test(t)) {
      return copy('Try asking about the choice within your control, such as “Should I contact them again?”', 'Kontrolünüzdeki bir seçimi sorun; örneğin “Onunla yeniden iletişime geçmeli miyim?”');
    }
    return '';
  }

  function questionReadyForDraw(raw) {
    return !validate(raw);
  }

  /* One free draw per rolling 24 hours. Normalize without discarding Turkish
     or other non-ASCII letters so equivalent questions remain equivalent. */
  function norm(v) {
    var value = String(v || '').toLocaleLowerCase(IS_TR ? 'tr-TR' : undefined);
    try { value = value.normalize('NFKC').replace(/[^\p{L}\p{N} ]/gu, ' '); }
    catch (_) { value = value.replace(/[^a-z0-9\u00c0-\u024f\u1e00-\u1eff\u011f\u0131\u015f\u00e7\u00f6\u00fc ]/gi, ' '); }
    return value.replace(/\s+/g, ' ').trim();
  }
  function activeLockRecord() {
    var store = {};
    try { store = JSON.parse(localStorage.getItem(KEY) || '{}'); } catch (_) { store = {}; }
    var expiresAt = Number(store.ts || 0) + 864e5;
    if (!store.ts || expiresAt <= Date.now() || POOL.indexOf(String(store.card || '')) < 0 || needsQualifiedSupport(store.question)) return null;
    return {
      card: String(store.card), question: String(store.question || '').slice(0, 180),
      readingId: String(store.rid || ''), authContext: String(store.authContext || ''), authorityRepairUsed: store.authorityRepairUsed === true, expiresAt: expiresAt
    };
  }
  function persistLockAuthorizationContext() {
    if (!s.previewContext || !s.readingId || !s.card || !s.q) return;
    try {
      var store = JSON.parse(localStorage.getItem(KEY) || '{}');
      if (!store || !store.ts || Number(store.ts) + 864e5 <= Date.now()) return;
      if (String(store.card || '') !== s.card || norm(store.question || '') !== norm(s.q)) return;
      store.rid = s.readingId;
      store.authContext = s.previewContext;
      store.authorityRepairUsed = s.authorityRepairUsed;
      localStorage.setItem(KEY, JSON.stringify(store));
    } catch (_) {}
  }
  function repairPreviewAuthority() {
    // A pre-fix session may hold an approved preview that is no longer the
    // visitor's current authority. Reverify once through the normal endpoint;
    // preserve the exact question, card, package and rolling free-draw lock.
    s.authorityRepairUsed = true;
    s.readingId = 'yn3-repair-' + Date.now().toString(36) + Math.random().toString(36).slice(2, 7);
    try {
      var store = JSON.parse(localStorage.getItem(KEY) || '{}');
      if (store.ts && Number(store.ts) + 864e5 > Date.now() && String(store.card || '') === s.card && norm(store.question || '') === norm(s.q)) {
        store.rid = s.readingId;
        store.authorityRepairUsed = true;
        localStorage.setItem(KEY, JSON.stringify(store));
      }
    } catch (_) {}
  }
  function lockCountdownLabel() {
    var expiresAt = Number(s.lockExpiresAt || 0);
    if (!expiresAt) {
      var lock = activeLockRecord();
      expiresAt = lock ? lock.expiresAt : 0;
    }
    var remaining = Math.max(0, expiresAt - Date.now());
    if (!remaining) return copy('available now', 'şimdi kullanılabilir');
    var totalMinutes = Math.max(1, Math.ceil(remaining / 6e4));
    var hours = Math.floor(totalMinutes / 60);
    var minutes = totalMinutes % 60;
    var hourUnit = copy('h', 'sa');
    var minuteUnit = copy('m', 'dk');
    return hours > 0 ? hours + ' ' + hourUnit + ' ' + minutes + ' ' + minuteUnit : minutes + ' ' + minuteUnit;
  }
  function syncDrawButton() {
    var composer = document.querySelector('[data-yn3-q]');
    if (composer) composer.readOnly = s.phase !== 'ask' || s.buying === true;
    var drawButton = document.querySelector('[data-yn3-act="draw"]');
    if (!drawButton) return;
    var drawLocked = !!s.limit;
    // Let the visitor submit incomplete text and receive its specific inline error.
    var drawDisabled = drawLocked || s.phase === 'drawing' || s.buying;
    drawButton.disabled = drawDisabled;
    drawButton.setAttribute('aria-disabled', drawDisabled ? 'true' : 'false');
    drawButton.classList.toggle('yn3-draw-locked', drawDisabled);
    var drawLabel = drawButton.querySelector('[data-yn3-draw-label]');
    if (drawLabel) drawLabel.textContent = drawLocked
      ? copy('Free draw available in ', 'Ücretsiz çekime ') + lockCountdownLabel()
      : drawButton.getAttribute('data-default-label');
  }
  function pick(question) {
    var key = norm(question);
    var store = {};
    try { store = JSON.parse(localStorage.getItem(KEY) || '{}'); } catch (_) { store = {}; }
    var now = Date.now();
    var active = store && store.ts && now - store.ts < 864e5 && POOL.indexOf(store.card) >= 0 && !needsQualifiedSupport(store.question);
    var savedKey = String(store.question || '').trim() ? norm(store.question) : String(store.key || '');
    if (active && savedKey === key) {
      return { restored: true, card: store.card, question: String(store.question || question), readingId: /^[a-z0-9-]{6,80}$/.test(String(store.rid || '')) ? store.rid : '', authContext: String(store.authContext || ''), authorityRepairUsed: store.authorityRepairUsed === true, expiresAt: Number(store.ts) + 864e5 };
    }
    if (active && savedKey !== key && String(store.question || '').trim()) {
      return { blocked: true, card: store.card, question: String(store.question).slice(0, 180), readingId: /^[a-z0-9-]{6,80}$/.test(String(store.rid || '')) ? store.rid : '', authContext: String(store.authContext || ''), authorityRepairUsed: store.authorityRepairUsed === true, expiresAt: Number(store.ts) + 864e5 };
    }
    var h = 0;
    for (var i = 0; i < key.length; i++) h = (h * 31 + key.charCodeAt(i)) % 100003;
    var extra = 0;
    try { var b = new Uint8Array(2); crypto.getRandomValues(b); extra = b[0] * 256 + b[1]; } catch (_) { extra = Math.floor(Math.random() * 65536); }
    var card = POOL[(h + extra) % POOL.length];
    var rid = 'yn3-' + now.toString(36) + Math.random().toString(36).slice(2, 7);
    var authContext = authorizationContextKey();
    /* Text that needs qualified support is never written to storage (validate() refuses it before a draw anyway). */
    if (!needsQualifiedSupport(question)) {
      try { localStorage.setItem(KEY, JSON.stringify({ key: key, question: String(question).trim().slice(0, 180), card: card, ts: now, rid: rid, authContext: authContext })); } catch (_) {}
    }
    return { card: card, question: String(question).trim().slice(0, 180), readingId: rid, authContext: authContext };
  }

  function activeTab() { return !document.hidden && document.visibilityState !== 'hidden'; }
  function scheduleVisibilityEvent(el, name, duration) {
    var key = (s.attemptId || 'page') + ':' + name;
    if (seenMilestones[key] || visibilityTimers[key]) return;
    var startedAt = Date.now();
    visibilityTimers[key] = window.setTimeout(function check() {
      if (!el.isConnected || !el.__yn3HalfVisible) { delete visibilityTimers[key]; return; }
      if (!activeTab() || (name.indexOf('free_result_') === 0 && !s.resultMode)) {
        startedAt = Date.now();
        visibilityTimers[key] = window.setTimeout(check, 250);
        return;
      }
      if (Date.now() - startedAt < duration) {
        visibilityTimers[key] = window.setTimeout(check, 250);
        return;
      }
      delete visibilityTimers[key];
      /* UI state must never depend on analytics consent or delivery. A visitor
         who declines tracking still needs the same checkout affordances. */
      if (name === 'free_result_viewed') {
        s.resultViewed = true;
        persistState();
        refreshStickyVisibility();
      }
      if (name === 'offer_viewed') refreshStickyVisibility();
      if (publishFunnelEvent(name, { category: s.category, intent: s.intent || '' }, { once: true })) seenMilestones[key] = true;
    }, 250);
  }
  function observeFunnelVisibility() {
    if (!('IntersectionObserver' in window)) return;
    if (!milestoneObserver) {
      milestoneObserver = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          entry.target.__yn3HalfVisible = entry.isIntersecting && entry.intersectionRatio >= 0.5;
          var name = entry.target.getAttribute('data-yn3-view-event');
          if (name === 'free_result_viewed') engagedVisible = entry.target.__yn3HalfVisible;
          if (entry.target.__yn3HalfVisible && name) scheduleVisibilityEvent(entry.target, name, 1000);
        });
      }, { threshold: [0, 0.5, 1] });
      engagedLastTick = Date.now();
      engagedTimer = window.setInterval(function () {
        var now = Date.now();
        if (engagedVisible && activeTab() && s.attemptId && s.resultMode && !s.resultEngaged) {
          engagedMs += Math.min(1000, now - engagedLastTick);
          if (engagedMs >= 5000 && publishFunnelEvent('free_result_engaged', { category: s.category }, { once: true })) {
            s.resultEngaged = true;
            persistState();
          }
        }
        engagedLastTick = now;
      }, 500);
    }
    document.querySelectorAll('[data-yn3-view-event]').forEach(function (el) {
      if (!el.__yn3Observed) { el.__yn3Observed = true; milestoneObserver.observe(el); }
    });
  }
  function railTierForPackage(id) {
    for (var i = 0; i < PKG.length; i++) if (PKG[i].id === id) return PKG[i].railTier;
    return 'deeper';
  }
  function packageForRailTier(tier) {
    for (var i = 0; i < PKG.length; i++) if (PKG[i].railTier === tier) return PKG[i];
    return null;
  }
  function pricingReadyFor(pack) {
    return !!(pack && s.pricing.status === 'ready' && pack.available && pack.price);
  }
  function displayPrice(pack) {
    return pricingReadyFor(pack) ? pack.price : (pack && pack.previewPrice ? pack.previewPrice : '—');
  }
  function localizedQuotePrice(quote, currency) {
    if (!quote) return '';
    var fallback = String(quote.formatted_price || '');
    /* Present every verified market price in the visitor's locale. Shopify's
       formatted response can expose ISO codes (TRY/BRL/EUR), which reads like
       machine output at the conversion anchor. The API's price_minor value is
       authoritative; Intl only changes its presentation. */
    var activeCurrency = String(currency || '').toUpperCase();
    if (/^[A-Z]{3}$/.test(activeCurrency) && Number.isInteger(Number(quote.price_minor))) {
      try {
        return new Intl.NumberFormat(PAGE_LANG.replace('_', '-'), {
          style: 'currency',
          currency: activeCurrency,
          currencyDisplay: 'symbol'
        }).format(Number(quote.price_minor) / 100);
      } catch (_) {}
    }
    return fallback;
  }
  function pricingContractSignature(snapshot) {
    snapshot = snapshot || {};
    var tiers = Array.isArray(snapshot.tiers) ? snapshot.tiers.map(function (item) {
      item = item || {};
      return [
        String(item.tier || ''), String(item.variant_id || ''),
        Number(item.price_minor) || 0, String(item.formatted_price || ''),
        item.available === true ? 1 : 0
      ].join(':');
    }).join('|') : '';
    return [
      String(snapshot.status || ''), String(snapshot.currency || ''),
      String(snapshot.error_code || ''), tiers
    ].join('~');
  }
  function applyPricingSnapshot(snapshot) {
    if (!snapshot || !/^(loading|ready|error)$/.test(String(snapshot.status || ''))) return;
    var tiers = Array.isArray(snapshot.tiers) ? snapshot.tiers.map(function (item) {
      item = item || {};
      var tier = cleanToken(item.tier, 20);
      return {
        tier: RAIL_TIERS.indexOf(tier) >= 0 ? tier : '',
        variant_id: /^\d{10,20}$/.test(String(item.variant_id || '')) ? String(item.variant_id) : '',
        price_minor: Number.isInteger(Number(item.price_minor)) && Number(item.price_minor) > 0 ? Number(item.price_minor) : null,
        formatted_price: String(item.formatted_price || '').replace(/[<>]/g, '').slice(0, 40),
        available: item.available === true
      };
    }).filter(function (item) { return item.tier; }) : [];
    var nextPricing = {
      status: String(snapshot.status),
      currency: /^[A-Z]{3}$/.test(String(snapshot.currency || '')) ? String(snapshot.currency) : '',
      latency_ms: Math.max(0, Number(snapshot.latency_ms) || 0),
      error_code: cleanToken(snapshot.error_code || '', 80),
      tiers: tiers
    };
    /* getPricingSnapshot() is also polled after a restored result. Ignore an
       identical contract so apply -> render -> syncRail cannot recurse. */
    if (pricingContractSignature(s.pricing) === pricingContractSignature(nextPricing)) return;
    s.pricing = nextPricing;
    PKG.forEach(function (pack) {
      var quote = tiers.find(function (item) { return item.tier === pack.railTier; });
      pack.price = quote && quote.available ? localizedQuotePrice(quote, nextPricing.currency) : '';
      pack.available = !!(quote && quote.available && quote.variant_id && quote.formatted_price);
      pack.variantId = quote ? quote.variant_id : '';
      pack.priceMinor = quote ? quote.price_minor : null;
    });
    if (s.pricing.status === 'loading') {
      publishFunnelEvent('price_check_started', { status: 'loading' }, { once: true });
    } else if (s.pricing.status === 'ready') {
      publishFunnelEvent('price_check_succeeded', { status: 'ready', currency: s.pricing.currency, latency_ms: s.pricing.latency_ms }, { once: true });
      publishFunnelEvent('price_shown', { status: 'ready', currency: s.pricing.currency, price_minor: (tiers[0] && tiers[0].price_minor) || 0 }, { once: true });
      if (s.checkoutQueued) window.setTimeout(continueQueuedCheckout, 0);
    } else {
      publishFunnelEvent('price_check_failed', { status: 'error', error_code: s.pricing.error_code || 'price_unavailable', latency_ms: s.pricing.latency_ms }, { once: true });
      s.buying = false;
      s.checkoutQueued = false;
    }
    render();
  }

  /* ------------ render ------------ */
  function bindAll(name, value) {
    document.querySelectorAll('[data-yn3-bind="' + name + '"]').forEach(function (el) {
      if (el.textContent !== value) el.textContent = value;
    });
  }
  function showPhase() {
    document.querySelectorAll('[data-yn3-show]').forEach(function (el) {
      var want = el.getAttribute('data-yn3-show').split(' ');
      var visibleDisplay = el.getAttribute('data-yn3-display') || '';
      el.style.display = want.indexOf(s.phase) >= 0 ? visibleDisplay : 'none';
    });
  }
  function refreshStickyVisibility() {
    var sticky = document.querySelector('[data-yn3-sticky]');
    if (!sticky) return;
    var overview = document.querySelector('.yn3-overview');
    var passedFreeResult = !!(overview && overview.getBoundingClientRect().bottom < Math.max(120, window.innerHeight * 0.35));
    var primaryCta = document.querySelector('[data-yn3-act="quickcheckout"]');
    var primaryCtaRect = primaryCta && primaryCta.getBoundingClientRect();
    var primaryCtaVisible = !!(primaryCtaRect && primaryCtaRect.bottom > 0 && primaryCtaRect.top < window.innerHeight);
    var top = document.getElementById('top');
    var passedAsk = !!(top && top.getBoundingClientRect().bottom < Math.max(140, window.innerHeight * 0.28));
    var visible = s.phase === 'ask' ? passedAsk : (s.phase === 'result' && s.resultViewed && !primaryCtaVisible && (passedFreeResult || !!s.intent));
    if (visible) {
      var primary = document.querySelector('[data-yn3-act="quickcheckout"]');
      var summary = document.querySelector('[data-yn3-act="checkout"]');
      [primary, summary].forEach(function (element) {
        if (!element || !element.offsetWidth || !element.offsetHeight) return;
        var rect = element.getBoundingClientRect();
        if (rect.bottom > 0 && rect.top < window.innerHeight) visible = false;
      });
    }
    sticky.style.display = visible ? 'flex' : 'none';
    document.body.classList.toggle('yn3-sticky-on', visible);
  }
  function render() {
    if (s.limit && Number(s.limit.expiresAt || 0) <= Date.now()) { s.limit = null; s.limitKept = false; }
    var c = s.card;
    var lean = c ? leanOf(c) : 'YES';
    var d = DIRS[lean];
    var cur = CURATED[c] || null;
    var category = categoryConfig();
    var intent = intentConfig();
    var pack = null;
    for (var i = 0; i < PKG.length; i++) if (PKG[i].id === s.pkg) pack = PKG[i];

    showPhase();
    document.querySelectorAll('[data-yn3]').forEach(function (root) {
      if (c) root.setAttribute('data-yn3-direction', lean); else root.removeAttribute('data-yn3-direction');
      root.classList.toggle('yn3-paid-only', s.paidOnly === true);
    });
    bindAll('charCount', s.q.length + ' / 180');
    bindAll('questionEcho', s.q);
    bindAll('lockCountdown', lockCountdownLabel());
    bindAll('heroStartPrice', displayPrice(PKG[0]));
    document.querySelectorAll('[data-yn3-returning]').forEach(function (el) { el.style.display = s.phase === 'result' && s.restored ? 'block' : 'none'; });
    var errBox = document.querySelector('[data-yn3-err]');
    if (errBox) {
      errBox.style.display = s.err ? 'flex' : 'none';
      /* Qualified-support copy reads as guidance, not as an input error (yn3.css). */
      if (s.err && needsQualifiedSupport(s.q)) errBox.setAttribute('data-yn3-support', ''); else errBox.removeAttribute('data-yn3-support');
      var et = errBox.querySelector('[data-yn3-errtext]'); if (et) et.textContent = s.err;
      var rw = errBox.querySelector('[data-yn3-act="rewrite"]');
      if (rw) {
        rw.hidden = !(s.err && s.rewrite);
        var rl = rw.querySelector('[data-yn3-rewrite-label]'); if (rl) rl.textContent = copy('Tap to ask instead:', 'Bunun yerine sorun:');
        var rt = rw.querySelector('[data-yn3-rewrite-text]'); if (rt) rt.textContent = s.rewrite || '';
      }
    }
    var questionInput = document.querySelector('[data-yn3-q]');
    if (questionInput) {
      if (s.err) {
        questionInput.setAttribute('aria-invalid', 'true');
        questionInput.setAttribute('aria-describedby', 'yn3-q-help yn3-q-error');
      } else {
        questionInput.removeAttribute('aria-invalid');
        questionInput.setAttribute('aria-describedby', 'yn3-q-help');
      }
    }
    var limitBox = document.querySelector('[data-yn3-limit]');
    if (limitBox) {
      limitBox.style.display = s.limit ? 'block' : 'none';
      /* No paid tiers next to the qualified-support message. */
      var quotaOffer = limitBox.querySelector('[data-yn3-quota-offer]');
      if (quotaOffer) quotaOffer.style.display = s.err && needsQualifiedSupport(s.q) ? 'none' : '';
      if (s.limit) {
        var remaining = Math.max(1, Math.ceil((Number(s.limit.expiresAt || 0) - Date.now()) / 36e5));
        bindAll('limitQuestion', String(s.limit.question || ''));
        bindAll('limitRemaining', String(remaining));
        bindAll('limitCountdown', lockCountdownLabel());
        bindAll('keepNewLabel', s.limitKept
          ? copy('Text kept · free draw in ', 'Metin korundu · ücretsiz çekime ') + lockCountdownLabel()
          : copy('Keep my text · free draw in ', 'Metnimi koru · ücretsiz çekime ') + lockCountdownLabel());
      }
    }
    syncDrawButton();

    if (c) {
      var face = document.querySelector('[data-yn3-face]');
      if (face) {
        var src = cardImg(c);
        if (face.getAttribute('src') !== src) face.setAttribute('src', src);
        face.setAttribute('alt', cardLabel(c) + ' · ' + copy('tarot card, upright', 'tarot kartı, dik'));
      }
      bindAll('cardName', cardLabel(c));
      bindAll('cardTheme', copy('Traditional symbolism', 'Geleneksel sembolizm') + ' · ' + d.label);
      bindAll('dirLabel', d.label);
      bindAll('dirLead', d.lead);
      document.querySelectorAll('[data-yn3-bind="criticalQuestion"]').forEach(function (el) {
        el.textContent = s.paidOnly ? (el.getAttribute('data-paid-heading') || '') : d.criticalQuestion;
      });
      document.querySelectorAll('[data-yn3-bind="resultTitle"]').forEach(function (el) {
        var title = el.getAttribute(s.paidOnly ? 'data-paid-title' : 'data-free-title');
        if (title != null) el.textContent = title;
      });
      bindAll('dirHead', d.head);
      bindAll('dirSub', d.sub);
      document.querySelectorAll('[data-yn3-dircolor]').forEach(function (el) { el.style.color = d.ink; });
      document.querySelectorAll('[data-yn3-dirink]').forEach(function (el) { el.style.color = d.ink; });
      var ins = document.querySelector('[data-yn3-insight]');
      if (ins) {
        ins.style.display = s.paidOnly ? 'none' : '';
        ins.setAttribute('aria-busy', s.fetching ? 'true' : 'false');
        ins.classList.toggle('yn3-reading-loading', s.fetching);
        var ip = ins.querySelector('[data-yn3-insighttext]');
        if (ip) ip.textContent = sanitizeFreeInsight(s.insight);
      }
      var restored = document.querySelector('[data-yn3-restored]');
      if (restored) restored.style.display = s.restored ? 'block' : 'none';
      var fallbackNote = document.querySelector('[data-yn3-fallback-note]');
      if (fallbackNote) {
        fallbackNote.style.display = s.serverFallback && !s.paidOnly ? 'block' : 'none';
        /* Plain customer wording only: say why this overview is the standard
           card meaning, never internal terms such as "fallback". */
        fallbackNote.textContent = s.resultMode === 'limit'
          ? copy('Your free personalized answers for today are used up, so this overview uses the standard meaning of your card. Your card and direction are unchanged.', 'Bugünkü ücretsiz kişisel yorum hakkınız doldu; bu özet kartınızın genel anlamını kullanıyor. Kartınız ve yönünüz değişmedi.')
          : /^(?:service_unavailable|network|timeout)$/.test(s.fallbackSource)
          ? copy('The personalized answer could not be prepared right now, so this overview uses the standard meaning of your card. Your card and direction are unchanged.', 'Kişisel yorum şu anda hazırlanamadı; bu özet kartınızın genel anlamını kullanıyor. Kartınız ve yönünüz değişmedi.')
          : copy('This overview uses the standard meaning of your card for this kind of question. Your card and direction are unchanged.', 'Bu özet, kartınızın bu tür sorulardaki genel anlamını kullanıyor. Kartınız ve yönünüz değişmedi.');
      }
      var paidOnlyNote = document.querySelector('[data-yn3-paid-only-note]');
      if (paidOnlyNote) {
        paidOnlyNote.style.display = s.paidOnly ? 'block' : 'none';
      }
    }

    bindAll('categoryLabel', category.label);
    bindAll('categoryDescription', category.description);
    bindAll('intentTitle', intent ? intent.title : copy('Choose what you need next', 'Sonraki adımda neye ihtiyacınız olduğunu seçin'));
    bindAll('intentQuestion', intent ? intent.question : copy('Choose one focus to shape the personalized reading.', 'Kişisel okumayı şekillendirmek için bir odak seçin.'));
    bindAll('intentDetail', intent ? intent.detail : copy('Your choice will not change the card or direction.', 'Seçiminiz kartı veya yönü değiştirmez.'));
    bindAll('reservedOne', intent ? intent.question : copy('Choose one focus to shape the personalized reading.', 'Kişisel okumayı şekillendirmek için bir odak seçin.'));
    bindAll('reservedTwo', intent ? intent.detail : copy('Your choice will not change the card or direction.', 'Seçiminiz kartı veya yönü değiştirmez.'));
    bindAll('offerEyebrow', intent && pack && pack.id === intent.pkg ? copy('Recommended for your selected focus', 'Seçtiğiniz odak için önerilen') : copy('Your selected reading depth', 'Seçtiğiniz okuma derinliği'));
    bindAll('offerName', pack ? pack.name : copy('Focused', 'Odaklı'));
    bindAll('checkoutName', pack ? pack.checkoutName : copy('Focused Personalized Answer', 'Odaklı Kişisel Yanıt'));
    var selectedPrice = s.pricing.status === 'error' ? copy('Unavailable', 'Kullanılamıyor') : displayPrice(pack);
    bindAll('offerPrice', selectedPrice);
    bindAll('offerLine1', pack ? pack.line1 : copy('Your selected follow-up answered directly', 'Seçtiğiniz devam odağı doğrudan yanıtlanır'));
    bindAll('offerWords', pack ? pack.words : copy('750–950 private, personalized words', '750–950 kelimelik özel, kişisel yorum'));
    bindAll('offerLine3', pack ? pack.line3 : copy('Both paths, warnings and three practical next steps', 'İki yol, uyarılar ve üç pratik sonraki adım'));
    var checkoutCopy = s.pricing.status === 'error'
      ? copy('Retry secure price check', 'Güvenli fiyat kontrolünü yeniden dene')
      : !pricingReadyFor(pack)
        ? copy('Continue when your market price is confirmed', 'Pazar fiyatınız doğrulandığında devam edin')
        : (intent && pack ? ((pack.id === 'focused' ? intent.cta : pack.cta) + ' — ' + pack.price) : copy('Choose a focus first', 'Önce bir odak seçin'));
    bindAll('intentCta', s.buying ? copy('Opening secure checkout…', 'Güvenli ödeme açılıyor…') : checkoutCopy);
    var quickCta = document.querySelector('[data-yn3-act="quickcheckout"]');
    if (quickCta) {
      quickCta.style.display = s.compareOpen ? 'none' : '';
      quickCta.disabled = s.buying === true || s.pricing.status === 'loading' || s.pricing.status === 'idle';
      quickCta.setAttribute('aria-busy', s.pricing.status === 'loading' || s.pricing.status === 'idle' ? 'true' : 'false');
    }
    document.querySelectorAll('[data-yn3-intent]').forEach(function (el) {
      var on = el.getAttribute('data-yn3-intent') === s.intent;
      el.setAttribute('aria-checked', on ? 'true' : 'false');
      el.classList.toggle('yn3-intent-sel', on);
    });
    document.querySelectorAll('[data-yn3-offer]').forEach(function (el) { el.style.display = intent ? '' : 'none'; });
    document.querySelectorAll('[data-yn3-compare]').forEach(function (el) { el.style.display = intent && s.compareOpen ? '' : 'none'; });
    if (intent) observeFunnelVisibility();

    bindAll('qSummary', s.q.trim() || copy('Your question', 'Sorunuz'));
    bindAll('pkgSummary', pack ? pack.name + ' · ' + pack.value : copy('Not selected yet', 'Henüz seçilmedi'));
    bindAll('totalLabel', displayPrice(pack));
    document.querySelectorAll('[data-yn3-price]').forEach(function (el) {
      var pricePack = packageForRailTier(railTierForPackage(el.getAttribute('data-yn3-price')));
      var ready = pricingReadyFor(pricePack);
      el.textContent = ready ? pricePack.price : displayPrice(pricePack);
      el.classList.remove('yn3-price-skeleton');
    });
    var cta = document.querySelector('[data-yn3-act="checkout"]');
    if (cta) {
      cta.textContent = s.buying ? copy('Opening secure checkout…', 'Güvenli ödeme açılıyor…')
        : s.pricing.status === 'error' ? copy('Retry secure price check', 'Güvenli fiyat kontrolünü yeniden dene')
        : pricingReadyFor(pack) ? copy('Continue with ', 'Devam et: ') + pack.name + ' — ' + pack.price
        : copy('Market price confirmation required', 'Pazar fiyatı doğrulaması gerekiyor');
      var ctaEnabled = s.pricing.status === 'error' || (pricingReadyFor(pack) && !s.buying);
      if (ctaEnabled) cta.removeAttribute('disabled'); else cta.setAttribute('disabled', '');
      cta.style.background = ctaEnabled ? '#171B2B' : '#E7DFD1';
      cta.style.color = ctaEnabled ? '#FBF8F2' : '#8A8175';
      cta.style.cursor = ctaEnabled ? 'pointer' : 'not-allowed';
      cta.setAttribute('aria-busy', s.pricing.status === 'loading' || s.pricing.status === 'idle' ? 'true' : 'false');
    }
    var packageTabStop = pricingReadyFor(pack) ? s.pkg : (PKG.find(function (item) { return pricingReadyFor(item); }) || {}).id;
    document.querySelectorAll('[data-yn3-pkg]').forEach(function (el) {
      var on = el.getAttribute('data-yn3-pkg') === s.pkg;
      var choice = PKG.find(function (item) { return item.id === el.getAttribute('data-yn3-pkg'); });
      el.setAttribute('aria-checked', on ? 'true' : 'false');
      el.setAttribute('tabindex', el.getAttribute('data-yn3-pkg') === packageTabStop ? '0' : '-1');
      el.setAttribute('aria-disabled', pricingReadyFor(choice) && !s.buying ? 'false' : 'true');
      el.setAttribute('aria-busy', s.pricing.status === 'loading' || s.pricing.status === 'idle' ? 'true' : 'false');
      if ('disabled' in el) el.disabled = !pricingReadyFor(choice) || s.buying === true;
      el.classList.toggle('yn3-pk-sel', on);
      el.classList.toggle('yn3-pk-busy', on && s.buying === true);
      var dot = el.querySelector('[data-yn3-dot]');
      if (dot) { dot.style.borderColor = on ? '#B08B57' : '#D6CCBA'; dot.style.background = on ? '#B08B57' : '#FFFFFF'; var inner = dot.firstElementChild; if (inner) inner.style.background = on ? '#FBF8F2' : 'transparent'; }
    });
    var ctxWrap = document.querySelector('[data-yn3-ctxwrap]');
    if (ctxWrap) ctxWrap.style.display = s.ctxOpen ? '' : 'none';
    var ctxToggle = document.querySelector('[data-yn3-act="ctxtoggle"]');
    if (ctxToggle) ctxToggle.setAttribute('aria-expanded', s.ctxOpen ? 'true' : 'false');
    var ctxRot = document.querySelector('[data-yn3-ctxrot]');
    if (ctxRot) ctxRot.style.transform = s.ctxOpen ? 'rotate(45deg)' : 'none';
    bindAll('ctxCount', s.ctx.length + ' / 700');

    var sticky = document.querySelector('[data-yn3-sticky]');
    if (sticky) {
      sticky.style.display = 'none';
      document.body.classList.remove('yn3-sticky-on');
      bindAll('stickyTop', s.phase === 'ask' ? copy('One focused question · one free card', 'Tek net soru · bir ücretsiz kart') : d.criticalQuestion);
      bindAll('stickyMain', s.phase === 'ask' ? (activeLockRecord() ? copy('Free draw available in ', 'Ücretsiz çekime ') + lockCountdownLabel() : copy('Your free draw is ready', 'Ücretsiz çekiminiz hazır')) : (intent && pack && pricingReadyFor(pack) ? pack.name + ' · ' + pack.price : copy('Continue from this question and card', 'Bu soru ve karttan devam et')));
      var sbtn = sticky.querySelector('[data-yn3-act="sticky"]');
      if (sbtn) {
        sbtn.textContent = s.phase === 'ask' ? copy('Ask my question', 'Sorumu sor') : (s.buying ? copy('Opening…', 'Açılıyor…') : (s.pricing.status === 'error' ? copy('Retry secure price check', 'Güvenli fiyat kontrolünü yeniden dene') : (intent && pricingReadyFor(pack) ? copy('Continue · ', 'Devam · ') + pack.price : copy('Choose focus', 'Odak seç'))));
        sbtn.disabled = s.buying === true || (s.phase !== 'ask' && s.pricing.status !== 'error' && !!intent && !pricingReadyFor(pack));
        sbtn.setAttribute('aria-busy', s.phase !== 'ask' && (s.buying || s.pricing.status === 'loading' || s.pricing.status === 'idle') ? 'true' : 'false');
      }
    }
    syncRail();
    persistState();
    observeFunnelVisibility();
    setTimeout(refreshStickyVisibility, 0);
  }

  /* ------------ canonical free preview (token + model insight) ------------ */
  function fetchReading() {
    if (activeFreeRequest && activeFreeRequest.identity !== readingAuthorizationKey()) cancelFreeRequest();
    if (s.fetching || checkoutAuthorized() || !s.card || !s.q.trim()) return;
    var requestContext = currentAuthorizationContext();
    var requestContextKey = authorizationContextKey(requestContext);
    var request = {
      identity: readingAuthorizationKey(),
      controller: typeof AbortController === 'function' ? new AbortController() : null,
      timer: 0
    };
    activeFreeRequest = request;
    function isCurrentRequest() {
      return activeFreeRequest === request && request.identity === readingAuthorizationKey();
    }
    s.fetching = true;
    clearPreviewAuthorization();
    var startedAt = Date.now();
    publishFunnelEvent('free_result_requested', { category: s.category }, { once: true });
    if (!s.insight) s.insight = localInsight();
    render();
    var sig = canonicalSignals(s.card);
    var body = {
      tool: PAGE, type: TYPE, spread: SPREAD,
      presentationVariant: 'yes-no-direct-v1',
      scope: SCOPE, confidence: CONFIDENCE,
      question: s.q.trim().slice(0, 240),
      context: '',
      signals: sig, cards: sig,
      curiosityQuestion: '', focus: '',
      visitorId: visitorId(),
      readingId: s.readingId,
      lang: requestContext.language,
      locale: requestContext.locale,
      country: requestContext.country,
      currency: requestContext.currency,
      market: requestContext.market,
      snapshotVersion: 'reading-snapshot-v2',
      funnelVersion: FUNNEL_VERSION
    };
    var ac = request.controller;
    var timer = ac ? setTimeout(function () { if (isCurrentRequest()) ac.abort(); }, 9000) : 0;
    request.timer = timer;
    fetch(API_FREE, {
      method: 'POST', headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(body), signal: ac ? ac.signal : undefined
    }).then(function (r) {
      return r.text().then(function (body) {
        var data = {};
        try { data = body ? JSON.parse(body) : {}; } catch (_) {}
        return { ok: r.ok, status: r.status, data: data && typeof data === 'object' ? data : {} };
      });
    })
      .then(function (res) {
        if (!isCurrentRequest()) return;
        if (res.data && (/(?:^|_)safety_blocked$/i.test(String(res.data.code || res.data.error || '')) || res.data.safety === true)) {
          refuseForSafety();
          return;
        }
        if (res.ok && res.data) {
          var nextToken = String(res.data.token || res.data.previewToken || '');
          if (!validPreviewToken(nextToken) || res.data.safety === true || res.data.offerAllowed === false) {
            throw new Error('preview_contract');
          }
          s.previewToken = nextToken;
          s.previewContext = requestContextKey;
          s.previewReadingContext = request.identity;
          s.transportFallback = false;
          s.transportFailure = '';
          persistLockAuthorizationContext();
          var raw = String(res.data.compactInsight || res.data.teaser || '');
          var cleanedInsight = raw.replace(/<[^>]*>/g, ' ').replace(/&(amp|lt|gt|quot|#39);/g, function (m, k) { return { amp: '&', lt: '<', gt: '>', quot: '"', '#39': "'" }[k]; }).replace(/\s+/g, ' ').trim();
          var servedSource = String(res.data.servedSource || 'api');
          /* The shared free allowance (all free tools, rolling 24 hours) can be
             used up before this device's own yes/no draw; the server then
             serves the standard card meaning. Report it as the limit. */
          var allowanceUsed = res.data.quotaFallback === true ||
            res.data.freeValueStatus === 'deterministic_quota_fallback' ||
            servedSource === 'deterministic_quota_fallback';
          s.serverFallback = allowanceUsed || /fallback/i.test(servedSource);
          s.fallbackSource = s.serverFallback ? servedSource : '';
          s.insight = s.serverFallback || (LOCALE_KEY !== 'en' && looksEnglishInsight(cleanedInsight))
            ? localInsight() : sanitizeFreeInsight(cleanedInsight);
          var resolvedMode = allowanceUsed ? 'limit' : s.serverFallback ? 'fallback' : 'success';
          if (!s.resultMode || allowanceUsed) s.resultMode = resolvedMode;
          publishFunnelEvent('free_result_resolved', { result_mode: s.resultMode, source: servedSource, latency_ms: Date.now() - startedAt }, { once: true });
          render();
          syncRail();
        } else {
          s.serverFallback = true;
          s.fallbackSource = 'service_unavailable';
          s.insight = localInsight();
          var reason = String(res.data && (res.data.error || res.data.reason) || '');
          var failureCode = transportFailureForStatus(res.status);
          var fallbackAllowed = !!failureCode && !(res.data && (res.data.safety === true || res.data.offerAllowed === false));
          s.previewContext = fallbackAllowed ? requestContextKey : '';
          s.previewReadingContext = fallbackAllowed ? request.identity : '';
          s.transportFallback = fallbackAllowed;
          s.transportFailure = fallbackAllowed ? failureCode : '';
          if (fallbackAllowed) persistLockAuthorizationContext();
          s.resultMode = /free_limit|rate_limit/i.test(reason) || res.status === 429 ? 'limit'
            : /validation|invalid|question|required/i.test(reason) || res.status === 400 ? 'validation_error' : 'server_error';
          publishFunnelEvent('free_result_resolved', { result_mode: s.resultMode, reason: s.resultMode, transport_failure: s.transportFailure, offer_allowed: checkoutAuthorized(), latency_ms: Date.now() - startedAt }, { once: true });
        }
      })
      .catch(function (error) {
        if (!isCurrentRequest()) return;
        s.serverFallback = true;
        s.fallbackSource = error && error.name === 'AbortError' ? 'timeout' : 'network';
        s.insight = localInsight();
        var failureCode = error && error.name === 'AbortError' ? 'timeout' : '';
        s.previewContext = failureCode ? requestContextKey : '';
        s.previewReadingContext = failureCode ? request.identity : '';
        s.transportFallback = !!failureCode;
        s.transportFailure = failureCode;
        if (failureCode) persistLockAuthorizationContext();
        s.resultMode = failureCode || 'network_error';
        publishFunnelEvent('free_result_resolved', { result_mode: s.resultMode, reason: s.resultMode, transport_failure: s.transportFailure, offer_allowed: checkoutAuthorized(), latency_ms: Date.now() - startedAt }, { once: true });
      })
      .finally(function () {
        if (timer) clearTimeout(timer);
        if (!isCurrentRequest()) {
          if (activeFreeRequest === request) { activeFreeRequest = null; s.fetching = false; }
          return;
        }
        activeFreeRequest = null;
        s.fetching = false;
        s.railReadingId = '';
        s.railPreviewToken = '';
        render();
        if (checkoutAuthorized()) {
          syncRail();
          if (s.checkoutQueued) continueQueuedCheckout();
        } else if (s.buying) {
          resetCheckout(copy('Your free overview is safe, but the secure checkout link could not be prepared. Please try again.', 'Ücretsiz özetiniz güvende; ancak güvenli ödeme bağlantısı hazırlanamadı. Lütfen yeniden deneyin.'), true);
        }
      });
  }

  /* ------------ shared rail (yes-no-direct) ------------ */
  function detailsLine() {
    var parts = [];
    var intent = intentConfig();
    if (intent) parts.push('Selected follow-up: ' + intent.question);
    parts.push('Question category: ' + categoryConfig().label);
    if (s.ctx.trim()) parts.push('Background: ' + s.ctx.trim().slice(0, 700));
    return parts.join(' ').slice(0, 1050);
  }
  function checkoutLoadMessage() {
    return copy('Secure checkout could not load. Your question and card are saved. Tap Retry secure price check to reconnect.', 'Güvenli ödeme yüklenemedi. Sorunuz ve kartınız kaydedildi. Yeniden bağlanmak için Güvenli fiyat kontrolünü yeniden dene düğmesine dokunun.');
  }
  function watchCheckoutRuntime(script) {
    var generation = ++railLoadGeneration;
    railRuntimeScript = script;
    railLoadStatus = 'loading';
    if (railLoadTimer) window.clearTimeout(railLoadTimer);
    function failed() {
      if (generation !== railLoadGeneration) return;
      if (window.DeckauraDeepReading && typeof window.DeckauraDeepReading.enable === 'function') { loaded(); return; }
      if (railLoadTimer) window.clearTimeout(railLoadTimer);
      railLoadTimer = 0;
      railLoadStatus = 'error';
      if (s.buying) resetCheckout('', false);
      applyPricingSnapshot({ status: 'error', error_code: 'checkout_script_unavailable', tiers: [] });
      setStatus(checkoutLoadMessage(), true);
    }
    function loaded() {
      if (generation !== railLoadGeneration) return;
      if (!window.DeckauraDeepReading || typeof window.DeckauraDeepReading.enable !== 'function') { failed(); return; }
      if (railLoadTimer) window.clearTimeout(railLoadTimer);
      railLoadTimer = 0;
      railLoadStatus = 'ready';
      setStatus('', false);
      syncRail();
    }
    script.addEventListener('load', loaded);
    script.addEventListener('error', failed);
    railLoadTimer = window.setTimeout(failed, 12000);
  }
  function mountCheckoutRail(retry) {
    if (window.DeckauraDeepReading && typeof window.DeckauraDeepReading.enable === 'function') return true;
    var template = document.getElementById('yn3-checkout-rail-template');
    var host = document.getElementById('yn3-checkout-rail-host');
    if (!template || !template.content || !host) return false;
    if (host.getAttribute('data-mounted') === 'true') {
      if (!retry || railLoadStatus === 'loading') return false;
      var oldRuntime = railRuntimeScript || host.querySelector('script[src*="deep-reading-cta-runtime.js"]');
      if (!oldRuntime || !oldRuntime.parentNode) return false;
      var replacement = document.createElement('script');
      Array.prototype.slice.call(oldRuntime.attributes).forEach(function (attr) { replacement.setAttribute(attr.name, attr.value); });
      // A timed-out request may still be pending. A fresh URL prevents the
      // browser from joining that old download when the visitor retries.
      var retrySource = new URL(oldRuntime.getAttribute('src'), window.location.href);
      retrySource.searchParams.set('_deckaura_retry', Date.now().toString(36) + '-' + (railLoadGeneration + 1));
      replacement.src = retrySource.href;
      watchCheckoutRuntime(replacement);
      oldRuntime.parentNode.replaceChild(replacement, oldRuntime);
      applyPricingSnapshot({ status: 'loading', error_code: '', tiers: [] });
      return false;
    }
    host.setAttribute('data-mounted', 'true');
    var fragment = template.content.cloneNode(true);
    Array.prototype.slice.call(fragment.querySelectorAll('script')).forEach(function (oldScript) {
      var nextScript = document.createElement('script');
      Array.prototype.slice.call(oldScript.attributes).forEach(function (attr) { nextScript.setAttribute(attr.name, attr.value); });
      nextScript.text = oldScript.textContent || '';
      if (/deep-reading-cta-runtime\.js(?:[?#]|$)/.test(nextScript.getAttribute('src') || '')) watchCheckoutRuntime(nextScript);
      oldScript.parentNode.replaceChild(nextScript, oldScript);
    });
    host.appendChild(fragment);
    return !!(window.DeckauraDeepReading && typeof window.DeckauraDeepReading.enable === 'function');
  }
  function reconcileRailPricing(api) {
    var snapshot = null;
    try { if (api && typeof api.getPricingSnapshot === 'function') snapshot = api.getPricingSnapshot(); } catch (_) {}
    if (snapshot) applyPricingSnapshot(snapshot);
    if (snapshot && snapshot.status === 'loading' && railPriceAttempts < 100) {
      if (!railPriceRetry) railPriceRetry = window.setTimeout(function () {
        railPriceRetry = 0;
        railPriceAttempts += 1;
        syncRail();
      }, 100);
    } else if (snapshot && snapshot.status !== 'loading') {
      if (railPriceRetry) window.clearTimeout(railPriceRetry);
      railPriceRetry = 0;
      railPriceAttempts = 0;
    }
  }
  function railCheckoutProperties() {
    var intent = intentConfig();
    var props = {
      '_Page Design': 'yes-no-tarot-intent-v2',
      '_Experiment Variant': FUNNEL_VARIANT,
      '_Question Category': s.category,
      '_Reading Category': s.category,
      '_Answer': s.card ? leanOf(s.card) : '',
      '_Card Name': s.card || '',
      '_Package Display Name': (PKG.find(function (item) { return item.id === s.pkg; }) || {}).checkoutName || '',
      '_analytics_schema': ANALYTICS_SCHEMA,
      '_funnel_version': FUNNEL_VERSION,
      '_attempt_id': s.attemptId,
      '_reading_id': s.readingId
    };
    if (intent) props['Reading focus'] = intent.title;
    var det = detailsLine();
    if (det) props['_Details'] = det;
    return props;
  }
  function enableRailPricing(api) {
    if (railEnabled) return true;
    /* The shared rail can resolve Liquid-backed market prices synchronously and
       invoke onPricingStateChange from inside enable(). Take the lock first so
       that render() cannot re-enter enable() and strand a later request. */
    railEnabled = true;
    try {
      api.enable({
        type: TYPE, teaser: false, resultReady: false,
        presentationVariant: 'yes-no-direct-v1',
        canonicalPage: PAGE, visitorId: visitorId(),
        question: '', readingId: 'yn3-prewarm-' + String(s.sessionId || Date.now()).replace(/[^a-zA-Z0-9_-]/g, '').slice(0, 60),
        curiosityQuestion: '', focus: '', context: '', signals: '', cards: '',
        spread: SPREAD, scope: SCOPE, confidence: CONFIDENCE, tool: PAGE,
        previewToken: '', transportFallback: false, checkoutPending: true,
        defaultTier: railTierForPackage(s.pkg),
        checkoutRecoveryHost: document.querySelector('[data-yn3-cart-review]'),
        onCartReviewReady: cartReviewReady,
        onPricingStateChange: applyPricingSnapshot,
        onPriceReady: function () {
          if (s.pricing.status === 'ready' && s.checkoutQueued) setTimeout(continueQueuedCheckout, 0);
        },
        checkoutGuard: function (detail) {
          var selected = (s.pricing.tiers || []).find(function (item) { return item.tier === detail.tier; });
          return s.pricing.status === 'ready' && !!(selected && selected.available && selected.variant_id === String(detail.variantId || ''));
        },
        checkoutProperties: railCheckoutProperties
      });
      reconcileRailPricing(api);
      return true;
    } catch (_) {
      railEnabled = false;
      return false;
    }
  }
  function syncRail() {
    if (railSyncing) return;
    mountCheckoutRail();
    var api = window.DeckauraDeepReading;
    if (!api || typeof api.enable !== 'function') {
      if (railLoadStatus !== 'error' && !railMountRetry && railMountAttempts < 40) railMountRetry = window.setTimeout(function () {
        railMountRetry = 0;
        railMountAttempts += 1;
        syncRail();
      }, 80);
      return;
    }
    if (railMountRetry) { window.clearTimeout(railMountRetry); railMountRetry = 0; }
    railMountAttempts = 0;
    if (!enableRailPricing(api)) return;
    if (!s.card || s.phase !== 'result') {
      reconcileRailPricing(api);
      return;
    }
    var authorizationKey = checkoutAuthorizationKey();
    if (s.railReadingId === s.readingId && s.railPreviewToken === authorizationKey) {
      try { if (typeof api.setCheckoutPending === 'function') api.setCheckoutPending(!checkoutAuthorized()); } catch (_) {}
      /* Price hydration may settle synchronously before the callback is fully
         attached, especially when a saved 24-hour result is restored. Pull the
         authoritative snapshot on each later render; identical snapshots are
         ignored by applyPricingSnapshot(). */
      reconcileRailPricing(api);
      return;
    }
    var sig = canonicalSignals(s.card);
    railSyncing = true;
    try {
      if (typeof api.update !== 'function') throw new Error('rail_update_unavailable');
      api.update({
        type: TYPE, teaser: false, resultReady: true,
        presentationVariant: 'yes-no-direct-v1',
        checkoutRecoveryHost: document.querySelector('[data-yn3-cart-review]'),
        onCartReviewReady: cartReviewReady,
        question: s.q.trim().slice(0, 240), readingId: s.readingId,
        curiosityQuestion: '', focus: '',
        context: '',
        signals: sig, cards: sig,
        spread: SPREAD,
        scope: SCOPE, confidence: CONFIDENCE,
        tool: PAGE, previewToken: validPreviewToken(s.previewToken) ? s.previewToken : '',
        transportFallback: s.transportFallback === true,
        transportFailure: s.transportFallback === true ? s.transportFailure : ''
      });
      if (typeof api.setPreviewAuthorization === 'function') {
        api.setPreviewAuthorization({
          previewToken: validPreviewToken(s.previewToken) ? s.previewToken : '',
          transportFallback: s.transportFallback === true,
          transportFailure: s.transportFallback === true ? s.transportFailure : ''
        });
      }
      if (typeof api.setTier === 'function') {
        api.setTier(railTierForPackage(s.pkg), 'user');
      }
      if (typeof api.setCheckoutPending === 'function') api.setCheckoutPending(!checkoutAuthorized());
      s.railReadingId = s.readingId;
      s.railPreviewToken = authorizationKey;
      /* Keep reconciling briefly because the hidden rail can finish its market
         price request after the restored-result render has gone idle. */
      reconcileRailPricing(api);
    } catch (_) {}
    finally { railSyncing = false; }
  }
  function setStatus(message, isError) {
    if (isError && checkoutCartReviewPending()) { message = ''; isError = false; }
    /* Qualified-support copy reads as guidance, near-white on the dark stage (yn3.css), not as a checkout error. */
    var support = !!message && (message === supportMessage('blocked') || message === supportMessage('urgent') || message === supportMessage('high'));
    document.querySelectorAll('[data-yn3-status]').forEach(function (el) {
      el.textContent = message || '';
      el.style.display = message ? 'block' : 'none';
      el.style.color = isError ? '#913F3F' : '#7E5A22';
      if (support) el.setAttribute('data-yn3-support', ''); else el.removeAttribute('data-yn3-support');
    });
  }
  function clearCartReview() {
    s.checkoutCartReview = null;
    var host = document.querySelector('[data-yn3-cart-review]');
    if (!host) return;
    host.__deckauraRecoveryGeneration = (host.__deckauraRecoveryGeneration || 0) + 1;
    host.textContent = '';
    host.hidden = true;
  }
  function selectPackage(packageId) {
    if (s.buying || !PKG.some(function (item) { return item.id === packageId; })) return false;
    if (s.pkg !== packageId) {
      clearCartReview();
      s.pkg = packageId;
    }
    return true;
  }
  function checkoutCartReviewReason(reason) {
    return /^(reading_cart_conflict|cart_changed|cart_operation_busy|cart_result_uncertain|cart_read_failed|cart_add_failed|checkout_guard_unavailable|checkout_navigation_busy)$/.test(String(reason || ''));
  }
  function checkoutCartReviewPending() {
    var review = s.checkoutCartReview;
    return !!(review && checkoutCartReviewReason(review.reason) && s.phase === 'result' && review.readingId === s.readingId && s.railReadingId === s.readingId && document.querySelector('[data-yn3-cart-review]'));
  }
  function cartReviewReady(host) {
    if (!host || s.phase !== 'result') return;
    var readingId = s.readingId, generation = host.__deckauraRecoveryGeneration;
    if (host.__yn3FocusedRecoveryGeneration === generation) return;
    host.__yn3FocusedRecoveryGeneration = generation;
    window.requestAnimationFrame(function () {
      if (s.phase !== 'result' || s.readingId !== readingId || host.hidden || host.isConnected === false || host.__deckauraRecoveryGeneration !== generation) return;
      host.setAttribute('tabindex', '-1');
      var reducedMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      try { host.scrollIntoView({ block: 'start', behavior: reducedMotion ? 'auto' : 'smooth' }); } catch (_) {}
      try { host.focus({ preventScroll: true }); } catch (_) {}
    });
  }
  /* A checkout the rail held because the question needs qualified support says so, never "try again". */
  function checkoutRefusal() {
    var api = window.DeckauraDeepReading, held = '';
    try { held = api && typeof api.getRiskKind === 'function' ? api.getRiskKind() : ''; } catch (_) { held = ''; }
    return held === 'urgent' || needsQualifiedSupport(s.q) ? supportFor(s.q) : '';
  }
  function resetCheckout(message, isError) {
    if (checkoutTimer) clearTimeout(checkoutTimer);
    checkoutTimer = 0;
    s.buying = false;
    s.checkoutQueued = false;
    s.checkoutVia = '';
    render();
    setStatus(message || '', isError === true);
  }
  function selectedRailTier() {
    return railTierForPackage(s.pkg);
  }
  function railCheckout(via) {
    var api = window.DeckauraDeepReading;
    if (!api || typeof api.checkoutNow !== 'function') return false;
    if (!checkoutAuthorized()) {
      s.checkoutQueued = true;
      s.checkoutVia = via || 'intent_offer';
      return null;
    }
    syncRail();
    var tier = selectedRailTier();
    var pack = PKG.find(function (item) { return item.id === s.pkg; });
    if (!pricingReadyFor(pack)) {
      s.checkoutQueued = true;
      s.checkoutVia = via || 'intent_offer';
      try { if (typeof api.retryPricing === 'function' && s.pricing.status === 'error') api.retryPricing(); } catch (_) {}
      return null;
    }
    try { api.setTier(tier, 'user'); } catch (_) { return false; }
    try {
      if (typeof api.getSelectedTier === 'function' && api.getSelectedTier() !== tier) return false;
      if (typeof api.isPriceReady === 'function' && !api.isPriceReady()) {
        s.checkoutQueued = true;
        s.checkoutVia = via || 'intent_offer';
        try { if (typeof api.retryPricing === 'function') api.retryPricing(); } catch (_) {}
        return null;
      }
      return api.checkoutNow() === true;
    } catch (_) { return false; }
  }
  function continueQueuedCheckout() {
    if (!s.checkoutQueued || !s.buying) return;
    if (!checkoutAuthorized()) { setStatus(copy('Preparing your secure reading link…', 'Güvenli okuma bağlantınız hazırlanıyor…'), false); return; }
    var via = s.checkoutVia || 'intent_offer';
    s.checkoutQueued = false;
    var started = railCheckout(via + '_ready');
    if (started === null) {
      s.checkoutQueued = true;
      setStatus(copy('Confirming the secure price for your market…', 'Pazarınız için güvenli fiyat doğrulanıyor…'), false);
      return;
    }
    if (!started) {
      resetCheckout(checkoutRefusal() || copy('Checkout did not open. Your reading is safe—please try again.', 'Ödeme açılmadı. Okumanız güvende; lütfen yeniden deneyin.'), true);
      return;
    }
    setStatus(copy('Opening secure checkout…', 'Güvenli ödeme açılıyor…'), false);
  }
  function startCheckout(via) {
    if (!s.intent) s.intent = 'condition';
    if (s.buying) return;
    ensureAttempt('checkout_cta');
    var tier = selectedRailTier();
    publishFunnelEvent('checkout_cta_clicked', { tier: tier, via: via, category: s.category, intent: s.intent });
    if (s.pricing.status === 'error') {
      var retryApi = window.DeckauraDeepReading;
      publishFunnelEvent('price_check_started', { status: 'loading', source: 'manual_retry' });
      setStatus(copy('Retrying the secure price for your market…', 'Pazarınız için güvenli fiyat yeniden kontrol ediliyor…'), false);
      railPriceAttempts = 0;
      if (!retryApi || typeof retryApi.enable !== 'function') {
        railMountAttempts = 0;
        mountCheckoutRail(true);
        syncRail();
        return;
      }
      try { if (typeof retryApi.retryPricing === 'function') retryApi.retryPricing(); } catch (_) {}
      reconcileRailPricing(retryApi);
      return;
    }
    var selectedPack = PKG.find(function (item) { return item.id === s.pkg; });
    if (!pricingReadyFor(selectedPack)) {
      setStatus(copy('Confirming the secure price for your market…', 'Pazarınız için güvenli fiyat doğrulanıyor…'), false);
      return;
    }
    s.buying = true;
    s.checkoutCartReview = null;
    s.checkoutVia = via || 'intent_offer';
    if (checkoutTimer) clearTimeout(checkoutTimer);
    checkoutTimer = setTimeout(function () {
      if (!s.buying) return;
      resetCheckout(copy('Checkout did not open. Your reading is safe—please try again.', 'Ödeme açılmadı. Okumanız güvende; lütfen yeniden deneyin.'), true);
    }, 18000);
    render();
    if (!checkoutAuthorized() && !s.fetching) fetchReading();
    var started = railCheckout(s.checkoutVia);
    if (started === null) setStatus(checkoutAuthorized()
      ? copy('Confirming the secure price for your market…', 'Pazarınız için güvenli fiyat doğrulanıyor…')
      : copy('Preparing your secure reading link…', 'Güvenli okuma bağlantınız hazırlanıyor…'), false);
    else if (!started) resetCheckout(checkoutRefusal() || copy('Checkout did not open. Your reading is safe—please try again.', 'Ödeme açılmadı. Okumanız güvende; lütfen yeniden deneyin.'), true);
    else setStatus(copy('Opening secure checkout…', 'Güvenli ödeme açılıyor…'), false);
  }

  /* ------------ flow ------------ */
  function goIntent() {
    var el = document.getElementById('yn3-intent');
    if (!el) return;
    try { window.scrollTo({ top: el.getBoundingClientRect().top + (window.pageYOffset || 0) - 20, behavior: 'auto' }); } catch (_) {}
  }
  function goDepth() {
    if (!s.intent) { goIntent(); return; }
    s.compareOpen = true;
    render();
    publishFunnelEvent('offer_opened', { category: s.category, intent: s.intent }, { once: true });
    var el = document.getElementById('depth');
    if (!el) return;
    setTimeout(function () {
      try { window.scrollTo({ top: el.getBoundingClientRect().top + (window.pageYOffset || 0) - 20, behavior: 'auto' }); } catch (_) {}
    }, 0);
  }
  function goOffer() {
    var offer = document.querySelector('[data-yn3-offer]');
    if (!offer) return;
    requestAnimationFrame(function () {
      requestAnimationFrame(function () {
        try {
          var top = offer.getBoundingClientRect().top + (window.pageYOffset || 0) - 12;
          window.scrollTo({ top: Math.max(0, top), behavior: 'auto' });
        } catch (_) {}
      });
    });
  }
  function showQuestionError(err) {
    s.err = err;
    s.rewrite = rewriteSuggestion(s.q);
    render();
    var invalidQuestion = document.querySelector('[data-yn3-q]');
    if (invalidQuestion) {
      try { invalidQuestion.focus({ preventScroll: true }); } catch (_) { try { invalidQuestion.focus(); } catch (_) {} }
    }
  }
  function onDraw() {
    if (s.phase !== 'ask' || s.buying) return;
    ensureAttempt('draw');
    if (s.limit) {
      /* The text stays editable under the limit box; check it before pointing at the paid tiers. */
      var limitErr = validate(s.q);
      if (limitErr) { showQuestionError(limitErr); return; }
      render();
      var existingLimit = document.querySelector('[data-yn3-limit]');
      if (existingLimit) { try { existingLimit.focus({ preventScroll: false }); } catch (_) {} }
      return;
    }
    var err = validate(s.q);
    if (err) {
      showQuestionError(err);
      return;
    }
    publishFunnelEvent('question_validated', { category: categoryOf(s.q) }, { once: true });
    publishFunnelEvent('draw_submitted', { category: categoryOf(s.q) }, { once: true });
    cancelFreeRequest();
    var picked = pick(s.q);
    if (picked.blocked) {
      s.err = '';
      s.limit = picked;
      s.resultMode = 'limit';
      s.lockExpiresAt = Number(picked.expiresAt || 0);
      s.limitKept = false;
      publishFunnelEvent('free_result_resolved', { result_mode: 'limit', reason: 'rolling_24h' }, { once: true });
      publishFunnelEvent('free_lock_hit', { reason: 'rolling_24h' }, { once: true });
      render();
      var limitHeading = document.querySelector('[data-yn3-limit]');
      if (limitHeading) { try { limitHeading.focus({ preventScroll: false }); } catch (_) {} }
      return;
    }
    s.err = '';
    clearCartReview();
    s.card = picked.card;
    s.restored = picked.restored === true;
    s.lockExpiresAt = Number(picked.expiresAt || (Date.now() + 864e5));
    s.limit = null;
    s.limitKept = false;
    s.paidOnly = false;
    s.serverFallback = false; s.fallbackSource = '';
    s.category = categoryOf(s.q);
    s.intent = 'condition';
    s.pkg = 'focused';
    s.compareOpen = false;
    s.readingId = picked.readingId || ('yn3-' + Date.now().toString(36) + Math.random().toString(36).slice(2, 7));
    s.authorityRepairUsed = picked.authorityRepairUsed === true;
    if (picked.restored === true && !authorizationContextMatches(picked.authContext)) {
      s.readingId = contextualReadingId(s.readingId, authorizationContextKey());
    }
    clearPreviewAuthorization();
    s.insight = localInsight();
    s.resultMode = '';
    s.resultViewed = false;
    s.resultEngaged = false;
    engagedMs = 0;
    s.checkoutQueued = false; s.checkoutVia = ''; s.buying = false;
    s.railReadingId = ''; s.railPreviewToken = '';
    publishFunnelEvent('draw_succeeded', { category: s.category }, { once: true });
    /* Start the model request while the 700ms card reveal runs. The result UI
       remains staged, but the explanation and checkout token arrive sooner. */
    fetchReading();
    var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    if (reduce) { finishDraw(); return; }
    s.phase = 'drawing';
    render();
    clearTimeout(drawTimer);
    drawTimer = setTimeout(finishDraw, 700);
  }
  function finishDraw() {
    s.phase = 'result';
    render();
    publishFunnelEvent('result_presented', { lean: leanOf(s.card), category: s.category }, { once: true });
    publishFunnelEvent('draw_completed', { lean: leanOf(s.card), category: s.category }, { once: true });
    var live = document.querySelector('[data-yn3-live]');
    if (live) live.textContent = copy('The card drawn is ', 'Çekilen kart ') + cardLabel(s.card) + '. ' + DIRS[leanOf(s.card)].lead;
    var resultRegion = document.querySelector('[data-yn3-result-region]');
    if (resultRegion) { try { resultRegion.focus({ preventScroll: true }); } catch (_) {} }
  }
  function onReset() {
    cancelFreeRequest();
    clearCartReview();
    var previousAnnouncement = document.querySelector('[data-yn3-live]');
    if (previousAnnouncement) previousAnnouncement.textContent = '';
    if (drawTimer) clearTimeout(drawTimer);
    drawTimer = 0;
    if (checkoutTimer) clearTimeout(checkoutTimer);
    checkoutTimer = 0;
    if (railMountRetry) clearTimeout(railMountRetry);
    railMountRetry = 0; railMountAttempts = 0;
    if (railPriceRetry) clearTimeout(railPriceRetry);
    railPriceRetry = 0; railPriceAttempts = 0;
    s.phase = 'ask'; s.q = ''; s.err = ''; s.card = ''; s.pkg = 'focused';
    s.ctx = ''; s.ctxOpen = false; s.restored = false; s.readingId = ''; clearPreviewAuthorization(); s.insight = ''; s.fetching = false;
    s.authorityRepairUsed = false;
    s.checkoutQueued = false; s.checkoutVia = ''; s.buying = false;
    s.railReadingId = ''; s.railPreviewToken = '';
    s.category = 'decision'; s.intent = 'condition'; s.limit = null; s.limitKept = false; s.paidOnly = false;
    s.serverFallback = false; s.fallbackSource = '';
    s.compareOpen = false;
    s.attemptId = ''; s.sentEvents = {}; s.questionStarted = false; s.resultMode = '';
    s.resultViewed = false; s.resultEngaged = false; engagedMs = 0;
    s.lockExpiresAt = Number((activeLockRecord() || {}).expiresAt) || 0;
    var q = document.querySelector('[data-yn3-q]');
    if (q) q.value = '';
    var cx = document.querySelector('[data-yn3-ctx]');
    if (cx) cx.value = '';
    try { sessionStorage.removeItem(SAVE_KEY); } catch (_) {}
    var resetRail = window.DeckauraDeepReading;
    // Retire the purchase owner even if this same saved reading is restored.
    // The next render re-enables the rail with its pricing and preview callbacks.
    railEnabled = false;
    try {
      if (resetRail && typeof resetRail.disable === 'function') resetRail.disable();
      else {
        if (resetRail && typeof resetRail.update === 'function') resetRail.update({ question: '', context: '', signals: '', cards: '', resultReady: false, readingId: 'yn3-prewarm-' + String(s.sessionId || Date.now()).replace(/[^a-zA-Z0-9_-]/g, '').slice(0, 60), previewToken: '', transportFallback: false });
        if (resetRail && typeof resetRail.setPreviewAuthorization === 'function') resetRail.setPreviewAuthorization({ previewToken: '', transportFallback: false });
        if (resetRail && typeof resetRail.setCheckoutPending === 'function') resetRail.setCheckoutPending(true);
      }
    } catch (_) {}
    ensureAttempt('change_question');
    render();
    try { window.scrollTo({ top: 0, behavior: 'auto' }); } catch (_) {}
  }

  function continueSavedReading() {
    if (!s.limit) return;
    clearCartReview();
    cancelFreeRequest();
    var saved = s.limit;
    s.q = String(saved.question || '').slice(0, 180);
    s.card = saved.card;
    s.readingId = saved.readingId || ('yn3-' + Date.now().toString(36) + Math.random().toString(36).slice(2, 7));
    s.authorityRepairUsed = saved.authorityRepairUsed === true;
    if (!authorizationContextMatches(saved.authContext)) {
      s.readingId = contextualReadingId(s.readingId, authorizationContextKey());
    }
    s.restored = true;
    s.paidOnly = false;
    s.serverFallback = false; s.fallbackSource = '';
    s.lockExpiresAt = Number(saved.expiresAt || (activeLockRecord() || {}).expiresAt) || 0;
    s.limit = null;
    s.category = categoryOf(s.q);
    s.intent = 'condition';
    s.pkg = 'focused';
    s.compareOpen = false;
    clearPreviewAuthorization();
    s.insight = localInsight();
    s.checkoutQueued = false; s.checkoutVia = ''; s.buying = false;
    s.railReadingId = ''; s.railPreviewToken = '';
    s.phase = 'result';
    var previousQuestion = document.querySelector('[data-yn3-q]');
    if (previousQuestion) previousQuestion.value = s.q;
    render();
    fetchReading();
    var restoredLive = document.querySelector('[data-yn3-live]');
    if (restoredLive) restoredLive.textContent = copy('Your saved free reading has been restored.', 'Kayıtlı ücretsiz okumanız geri yüklendi.');
  }
  function backToDraw() {
    if (s.phase === 'result') onReset();
    var q = document.querySelector('[data-yn3-q]');
    try { window.scrollTo({ top: 0, behavior: 'auto' }); } catch (_) {}
    if (q) window.setTimeout(function () { try { q.focus({ preventScroll: true }); } catch (_) { q.focus(); } }, 0);
  }

  function saveQuotaHandoff(tier) {
    var question = String(s.q || '').trim().slice(0, 180);
    if (validate(question)) return false;
    try {
      sessionStorage.setItem(QUOTA_HANDOFF_KEY, JSON.stringify({
        source: 'yes-no-quota',
        focus: 'yes-no',
        tier: String(tier || '').replace(/[^a-z-]/g, '').slice(0, 24),
        question: question,
        createdAt: Date.now()
      }));
      return true;
    } catch (_) {
      return false;
    }
  }

  function paidOnlyCard(question) {
    var key = norm(question), hash = 0, extra = 0;
    for (var i = 0; i < key.length; i++) hash = (hash * 31 + key.charCodeAt(i)) % 100003;
    try { var bytes = new Uint8Array(2); crypto.getRandomValues(bytes); extra = bytes[0] * 256 + bytes[1]; }
    catch (_) { extra = Math.floor(Math.random() * 65536); }
    return POOL[(hash + extra) % POOL.length];
  }
  function startQuotaPaid(tier) {
    var packageId = PKG.some(function (item) { return item.id === tier; }) ? tier : 'focused';
    var question = String(s.q || '').trim().slice(0, 180);
    var invalid = validate(question);
    if (invalid) {
      /* The visitor edited the text after the limit box opened: say why the
         tier did not continue instead of leaving a silent dead button. */
      showQuestionError(invalid);
      var errBox = document.querySelector('[data-yn3-err]');
      if (errBox) { try { errBox.scrollIntoView({ block: 'center', behavior: 'auto' }); } catch (_) {} }
      return;
    }
    cancelFreeRequest();
    clearCartReview();
    var previousAnnouncement = document.querySelector('[data-yn3-live]');
    if (previousAnnouncement) previousAnnouncement.textContent = '';
    ensureAttempt('quota_paid');
    s.limitKept = true;
    s.paidOnly = true;
    s.restored = false;
    s.limit = null;
    s.category = categoryOf(question);
    s.intent = 'condition';
    s.pkg = packageId;
    s.card = paidOnlyCard(question);
    s.readingId = 'yn3-paid-' + Date.now().toString(36) + Math.random().toString(36).slice(2, 7);
    s.authorityRepairUsed = false;
    s.resultMode = '';
    s.serverFallback = false; s.fallbackSource = '';
    s.compareOpen = false;
    s.phase = 'result';
    clearPreviewAuthorization();
    s.insight = '';
    s.checkoutQueued = false; s.checkoutVia = ''; s.buying = false;
    s.railReadingId = ''; s.railPreviewToken = '';
    publishFunnelEvent('quota_paid_handoff_clicked', { tier: selectedRailTier(), handoff_saved: 'same_page' });
    render();
    fetchReading();
    window.setTimeout(function () { goOffer(); startCheckout('quota_tier'); }, 0);
  }

  /* ------------ events ------------ */
  document.addEventListener('click', function (ev) {
    var t = ev.target;
    if (!t || !t.closest) return;
    var quotaLink = t.closest('[data-yn3-quota-tier]');
    if (quotaLink && quotaLink.closest('[data-yn3-limit]')) {
      ev.preventDefault();
      var quotaTier = quotaLink.getAttribute('data-yn3-quota-tier') || '';
      startQuotaPaid(quotaTier);
      return;
    }
    var fq = t.closest('[data-yn3-faq]');
    if (fq && fq.closest('[data-yn3]')) {
      var open = fq.getAttribute('aria-expanded') === 'true';
      var box = fq.nextElementSibling;
      var sign = fq.querySelector('span[aria-hidden]');
      fq.setAttribute('aria-expanded', open ? 'false' : 'true');
      if (box) box.style.display = open ? 'none' : 'block';
      if (sign) sign.style.transform = open ? 'none' : 'rotate(45deg)';
      return;
    }
    var example = t.closest('[data-yn3-example]');
    if (example && example.closest('[data-yn3]')) {
      ev.preventDefault();
      if (s.phase !== 'ask') onReset();
      var exampleQuestion = String(example.getAttribute('data-yn3-example') || '').slice(0, 180);
      var question = document.querySelector('[data-yn3-q]');
      s.q = exampleQuestion; s.err = ''; s.limit = null;
      if (question) { question.value = exampleQuestion; try { question.focus({ preventScroll: true }); } catch (_) {} }
      ensureAttempt('question_example');
      if (!s.questionStarted) { s.questionStarted = true; publishFunnelEvent('question_started', { category: categoryOf(s.q), source: 'example' }, { once: true }); }
      render();
      return;
    }
    var intentEl = t.closest('[data-yn3-intent]');
    if (intentEl && intentEl.closest('[data-yn3]')) {
      ensureAttempt('focus_selected');
      s.intent = intentEl.getAttribute('data-yn3-intent');
      s.pkg = (INTENTS[s.intent] && INTENTS[s.intent].pkg) || 'focused';
      s.compareOpen = false;
      publishFunnelEvent('focus_selected', { category: s.category, intent: s.intent });
      render();
      goOffer();
      return;
    }
    var pk = t.closest('[data-yn3-pkg]');
    if (pk && pk.closest('[data-yn3]')) {
      if (s.buying) return;
      ensureAttempt('package_selected');
      if (!selectPackage(pk.getAttribute('data-yn3-pkg'))) return;
      render();
      publishFunnelEvent('package_selected', { tier: selectedRailTier(), source: s.compareOpen ? 'comparison' : 'recommended_offer' });
      return;
    }
    var act = t.closest('[data-yn3-act]');
    if (!act || !act.closest('[data-yn3]')) return;
    var a = act.getAttribute('data-yn3-act');
    if (a === 'draw') { ev.preventDefault(); onDraw(); }
    else if (a === 'rewrite') {
      ev.preventDefault();
      if (!s.rewrite || s.phase !== 'ask') return;
      var rewritten = s.rewrite;
      var composer = document.querySelector('[data-yn3-q]');
      s.q = rewritten; s.err = ''; s.rewrite = '';
      if (composer) { composer.value = rewritten; composer.removeAttribute('aria-invalid'); }
      bindAll('charCount', s.q.length + ' / 180');
      publishFunnelEvent('question_rewritten', { category: categoryOf(s.q) }, { once: true });
      onDraw();
    }
    else if (a === 'reset') { ev.preventDefault(); onReset(); }
    else if (a === 'continuesaved') { ev.preventDefault(); continueSavedReading(); }
    else if (a === 'keepnew') { ev.preventDefault(); s.limitKept = true; render(); }
    else if (a === 'depth') { ev.preventDefault(); goDepth(); }
    else if (a === 'compare') { ev.preventDefault(); goDepth(); }
    else if (a === 'compareclose') { ev.preventDefault(); s.compareOpen = false; render(); goOffer(); }
    else if (a === 'ctxtoggle') { ev.preventDefault(); s.ctxOpen = !s.ctxOpen; render(); }
    else if (a === 'checkout') { ev.preventDefault(); if (s.pkg) startCheckout('summary_cta'); }
    else if (a === 'quickcheckout') { ev.preventDefault(); render(); startCheckout('intent_offer'); }
    else if (a === 'sticky') { ev.preventDefault(); if (s.phase === 'ask') backToDraw(); else if (s.pkg) startCheckout('sticky'); }
    else if (a === 'backtodraw') { ev.preventDefault(); backToDraw(); }
  });
  document.addEventListener('keydown', function (ev) {
    var questionInput = ev.target && ev.target.matches && ev.target.matches('[data-yn3-q]');
    if (questionInput && ev.key === 'Enter' && !ev.shiftKey && !ev.isComposing) {
      ev.preventDefault();
      onDraw();
      return;
    }
    var intentEl = ev.target && ev.target.closest && ev.target.closest('[data-yn3-intent]');
    if (intentEl && (ev.key === ' ' || ev.key === 'Enter')) {
      ev.preventDefault();
      ensureAttempt('focus_selected');
      s.intent = intentEl.getAttribute('data-yn3-intent');
      s.pkg = (INTENTS[s.intent] && INTENTS[s.intent].pkg) || 'focused';
      s.compareOpen = false;
      publishFunnelEvent('focus_selected', { category: s.category, intent: s.intent });
      render();
      goOffer();
      return;
    }
    var pk = ev.target && ev.target.closest && ev.target.closest('[data-yn3-pkg]');
    if (pk && s.buying) { ev.preventDefault(); return; }
    if (pk && /^(ArrowLeft|ArrowRight|ArrowUp|ArrowDown|Home|End)$/.test(ev.key)) {
      var choices = Array.prototype.slice.call(document.querySelectorAll('[data-yn3-pkg]')).filter(function (el) {
        var choice = PKG.find(function (item) { return item.id === el.getAttribute('data-yn3-pkg'); });
        return el.closest('[data-yn3]') && pricingReadyFor(choice) && !el.disabled;
      });
      if (!choices.length) return;
      ev.preventDefault();
      var at = choices.indexOf(pk), next = ev.key === 'Home' ? 0 : ev.key === 'End' ? choices.length - 1
        : (Math.max(0, at) + (/^(ArrowLeft|ArrowUp)$/.test(ev.key) ? -1 : 1) + choices.length) % choices.length;
      var nextChoice = choices[next];
      ensureAttempt('package_selected');
      if (!selectPackage(nextChoice.getAttribute('data-yn3-pkg'))) return;
      render();
      publishFunnelEvent('package_selected', { tier: selectedRailTier(), source: s.compareOpen ? 'comparison' : 'recommended_offer' });
      try { nextChoice.focus({ preventScroll: true }); } catch (_) { try { nextChoice.focus(); } catch (_) {} }
      return;
    }
    if (pk && (ev.key === ' ' || ev.key === 'Enter')) {
      var keyboardPack = PKG.find(function (item) { return item.id === pk.getAttribute('data-yn3-pkg'); });
      if (!pricingReadyFor(keyboardPack) || pk.disabled) return;
      ev.preventDefault();
      ensureAttempt('package_selected');
      if (!selectPackage(pk.getAttribute('data-yn3-pkg'))) return;
      render();
      publishFunnelEvent('package_selected', { tier: selectedRailTier(), source: s.compareOpen ? 'comparison' : 'recommended_offer' });
    }
  });
  document.addEventListener('input', function (ev) {
    var t = ev.target;
    if (!t || !t.matches) return;
    if (t.matches('[data-yn3-q]')) {
      if (s.phase !== 'ask' || s.buying) { t.value = s.q; return; }
      /* Hafif yol: sayac + CTA durumu birlikte guncellenir (olu-buton dersi). */
      ensureAttempt('question_input');
      s.q = t.value;
      if (!s.questionStarted && s.q.trim()) {
        s.questionStarted = true;
        publishFunnelEvent('question_started', { category: categoryOf(s.q) }, { once: true });
      }
      if (s.err) {
        s.err = ''; s.rewrite = '';
        var eb = document.querySelector('[data-yn3-err]'); if (eb) eb.style.display = 'none';
        var qo = document.querySelector('[data-yn3-quota-offer]'); if (qo) qo.style.display = '';
      }
      t.removeAttribute('aria-invalid');
      t.setAttribute('aria-describedby', 'yn3-q-help');
      bindAll('charCount', s.q.length + ' / 180');
      syncDrawButton();
      persistState();
    } else if (t.matches('[data-yn3-ctx]')) {
      s.ctx = t.value.slice(0, 700);
      bindAll('ctxCount', s.ctx.length + ' / 700');
      persistState();
    }
  });
  var stickyTick = false;
  function queueStickyRefresh() {
    if (stickyTick) return;
    stickyTick = true;
    requestAnimationFrame(function () { stickyTick = false; refreshStickyVisibility(); });
  }
  window.addEventListener('scroll', queueStickyRefresh, { passive: true });
  window.addEventListener('resize', queueStickyRefresh, { passive: true });
  document.addEventListener('deckaura:funnel-event', function (ev) {
    var detail = ev && ev.detail || {};
    var payload = detail.data && typeof detail.data === 'object' ? detail.data : {};
    var name = detail.name || '';
    var readingType = detail.readingType || payload.reading_type || '';
    if (readingType && readingType !== TYPE) return;
    if (payload.presentation_variant && payload.presentation_variant !== 'yes-no-direct-v1') return;
    // Direct tools emit a privacy-safe status under data; older rails emitted
    // a reason on the event itself. Both describe the same checkout outcome.
    var reason = String(detail.reason || payload.reason || payload.status || '');
    if ((payload.page || payload.tool) !== PAGE || s.phase !== 'result' || !s.readingId || s.railReadingId !== s.readingId) return;
    if (name === 'checkout_prepare_start') {
      s.buying = true;
      s.checkoutCartReview = null;
      s.checkoutQueued = false;
      if (checkoutTimer) clearTimeout(checkoutTimer);
      checkoutTimer = 0;
      render();
    } else if (name === 'checkout_cart_ready') {
      publishFunnelEvent('checkout_cart_verified', { tier: selectedRailTier() }, { once: true });
    } else if (name === 'checkout_redirect_success') {
      if (checkoutTimer) clearTimeout(checkoutTimer);
      checkoutTimer = 0;
      publishFunnelEvent('checkout_started', { tier: selectedRailTier(), via: s.checkoutVia || 'package_cta' }, { once: true });
    } else if (name === 'checkout_prepare_error') {
      s.checkoutCartReview = checkoutCartReviewReason(reason) ? { readingId: s.readingId, reason: reason } : null;
      publishFunnelEvent('checkout_failed', { tier: selectedRailTier(), reason: reason || 'prepare_error' });
      if (s.buying) {
        var failureCode = String(detail.code || payload.code || '').toUpperCase();
        /* The server refused the question for safety: show the support message, with no retry and no new reading. */
        if (/(?:^|_)SAFETY_BLOCKED$/i.test(failureCode) || /safety_blocked/i.test(String(reason || ''))) { holdForSafety(); resetCheckout(supportMessage('blocked'), true); return; }
        var previewInvalid = failureCode === 'DIRECT_TAROT_PREVIEW_EXPIRED_OR_INVALID';
        var legacyAuthorizationFailure = !failureCode && !Number(detail.http_status || payload.http_status) && /checkout_intent_unavailable|invalid_checkout_intent|preview_contract/.test(reason);
        var refreshAuthorization = (previewInvalid && !s.authorityRepairUsed) || legacyAuthorizationFailure;
        if (refreshAuthorization) {
          cancelFreeRequest();
          if (previewInvalid) repairPreviewAuthority();
          clearPreviewAuthorization();
          s.railReadingId = ''; s.railPreviewToken = '';
        }
        resetCheckout(copy('Checkout did not open. Your reading is safe—please try again.', 'Ödeme açılmadı. Okumanız güvende; lütfen yeniden deneyin.'), true);
        if (refreshAuthorization) fetchReading();
      }
      if (checkoutCartReviewPending()) setStatus('', false);
    }
  });
  window.addEventListener('pageshow', function () {
    if (checkoutTimer) clearTimeout(checkoutTimer);
    checkoutTimer = 0;
    s.buying = false; s.checkoutQueued = false; s.checkoutVia = '';
    s.railReadingId = ''; s.railPreviewToken = '';
    setStatus('', false);
    render();
    if (s.phase === 'result') {
      if (checkoutAuthorized()) syncRail();
      else fetchReading();
    }
  });
  // Browsing this tool must never remove a reading from the shared cart.

  function applyQuestionHandoff() {
    var queryQuestion = '', payload = null;
    try { queryQuestion = String(new URL(window.location.href).searchParams.get('question') || ''); } catch (_) {}
    try {
      payload = JSON.parse(sessionStorage.getItem('deckaura_reading_handoff') || 'null');
      if (payload && payload.createdAt && Date.now() - Number(payload.createdAt) > 60 * 60 * 1000) payload = null;
    } catch (_) { payload = null; }
    var question = String(queryQuestion || (payload && payload.question) || '').replace(/\s+/g, ' ').trim().slice(0, 180);
    if (question.length < 8) return false;
    cancelFreeRequest();
    try { sessionStorage.removeItem(SAVE_KEY); } catch (_) {}
    s.q = question; s.err = ''; s.phase = 'ask'; s.card = ''; s.ctx = ''; s.ctxOpen = false; s.restored = false;
    s.readingId = ''; clearPreviewAuthorization(); s.insight = ''; s.fetching = false; s.buying = false;
    s.authorityRepairUsed = false;
    s.checkoutQueued = false; s.checkoutVia = ''; s.railReadingId = ''; s.railPreviewToken = '';
    s.category = categoryOf(question); s.intent = 'condition'; s.pkg = 'focused'; s.compareOpen = false; s.limit = null;
    s.attemptId = ''; s.sentEvents = {}; s.questionStarted = false; s.resultMode = '';
    s.resultViewed = false; s.resultEngaged = false;
    var notice = document.getElementById('yn3-question-handoff');
    if (notice) notice.hidden = false;
    try { sessionStorage.removeItem('deckaura_reading_handoff'); } catch (_) {}
    try {
      var cleanUrl = new URL(window.location.href);
      cleanUrl.searchParams.delete('question'); cleanUrl.searchParams.delete('source');
      cleanUrl.searchParams.delete('intent'); cleanUrl.searchParams.delete('topic');
      cleanUrl.searchParams.delete('fresh');
      history.replaceState(history.state, '', cleanUrl.pathname + cleanUrl.search + cleanUrl.hash);
    } catch (_) {}
    return true;
  }

  s.sessionId = sessionId();
  var handoffApplied = applyQuestionHandoff();
  var restoredSession = handoffApplied ? false : restoreState();
  if (!s.sessionId) s.sessionId = sessionId();
  var initialQuestion = document.querySelector('[data-yn3-q]');
  if (initialQuestion) initialQuestion.value = s.q;
  var initialContext = document.querySelector('[data-yn3-ctx]');
  if (initialContext) initialContext.value = s.ctx;
  render();
  window.setInterval(function () {
    bindAll('lockCountdown', lockCountdownLabel());
    if (s.limit) render();
    else if (s.phase === 'ask') bindAll('stickyMain', activeLockRecord() ? copy('Free draw available in ', 'Ücretsiz çekime ') + lockCountdownLabel() : copy('Your free draw is ready', 'Ücretsiz çekiminiz hazır'));
  }, 30000);
  if (restoredSession) {
    if (checkoutAuthorized()) syncRail();
    else fetchReading();
  }
  publishFunnelEvent('yes_no_funnel_viewed', { source: handoffApplied ? 'question_handoff' : (restoredSession ? 'restored' : 'new') });
})();
